import { getPathPropsInterface } from '../../../interfaces/commonInterfaces';

const getPath = (name: string, props: getPathPropsInterface) => {
  const { fill = 'var(--text-secondary' } = props;
  switch (name) {
    case 'initial-text':
      return (
        <>
          <path
            fill={fill}
            d='M1.25 18.344v-1.239h.28c.28 0 .53-.046.748-.14.218-.093.413-.257.584-.49.187-.25.366-.608.538-1.075L8.47 1.662h3.2l4.884 13.761c.155.436.32.78.49 1.028.187.234.382.405.584.514.219.094.452.14.701.14h.421v1.239h-7.71v-1.239h.91c.235 0 .46-.07.679-.21.218-.14.327-.374.327-.7 0-.125-.016-.25-.047-.375a2.337 2.337 0 0 0-.07-.35 2.933 2.933 0 0 0-.094-.28l-.817-2.337H6.25l-.678 2.01c-.03.124-.07.264-.116.42-.047.156-.086.32-.117.49a2.165 2.165 0 0 0-.047.421c0 .296.11.522.327.678.218.156.46.233.724.233h.982v1.239H1.25Zm5.49-6.916h4.72l-1.238-3.832-.35-1.145c-.125-.42-.242-.84-.351-1.261L9.217 4.02c-.062.25-.14.522-.233.818-.094.28-.187.577-.28.888-.094.296-.195.6-.304.911-.094.296-.187.577-.28.841l-1.38 3.949Z'
          />
        </>
      );
    case 'git-hub':
      return (
        <>
          <path
            fill={fill}
            d='M14.39 2.453A8.393 8.393 0 0 0 10 1.25a8.4 8.4 0 0 0-4.393 1.203 8.826 8.826 0 0 0-3.183 3.264C1.64 7.092 1.25 8.592 1.25 10.22c0 1.954.557 3.71 1.67 5.272 1.112 1.558 2.549 2.641 4.311 3.239.205.039.357.012.455-.082a.462.462 0 0 0 .148-.35l-.005-.632c-.004-.397-.007-.743-.007-1.04l-.261.047a3.224 3.224 0 0 1-.633.04 4.67 4.67 0 0 1-.791-.081 1.748 1.748 0 0 1-.76-.35 1.483 1.483 0 0 1-.502-.718l-.114-.27a2.885 2.885 0 0 0-.359-.594c-.163-.22-.328-.367-.495-.445l-.08-.058a.931.931 0 0 1-.149-.14.634.634 0 0 1-.1-.163c-.024-.056-.005-.1.055-.135.06-.037.171-.053.33-.053l.229.035c.15.031.339.125.563.28.224.156.409.358.552.608.175.319.386.562.633.73.247.167.496.251.747.251.249 0 .466-.02.648-.059.182-.039.354-.097.512-.174.07-.523.256-.924.559-1.204a7.68 7.68 0 0 1-1.167-.211 4.505 4.505 0 0 1-1.07-.456 3.04 3.04 0 0 1-.918-.783c-.242-.309-.442-.72-.597-1.223-.155-.508-.233-1.09-.233-1.752 0-.942.298-1.744.899-2.407-.282-.708-.256-1.502.08-2.383.22-.07.546-.017.98.158.432.174.748.325.95.448.201.126.363.23.484.316a8.021 8.021 0 0 1 2.185-.298c.753 0 1.481.101 2.188.303l.432-.28a6.207 6.207 0 0 1 1.049-.514c.404-.156.712-.198.925-.128.341.88.372 1.673.09 2.383.6.66.9 1.463.9 2.405 0 .661-.078 1.247-.234 1.758-.155.51-.357.92-.604 1.228a3.204 3.204 0 0 1-.922.777c-.368.21-.727.36-1.07.454a7.513 7.513 0 0 1-1.169.21c.395.349.593.901.593 1.658v2.465c0 .14.047.255.142.349.095.093.244.121.45.082 1.763-.601 3.2-1.68 4.312-3.243 1.112-1.558 1.669-3.317 1.669-5.27 0-1.627-.392-3.128-1.174-4.502a8.832 8.832 0 0 0-3.183-3.264h-.002Z'
          />
        </>
      );
    case 'git-lab':
      return (
        <>
          <path
            fill={fill}
            d='m18.459 8.175-.025-.063-2.382-6.454a.62.62 0 0 0-1.184.067l-1.61 5.108H6.747L5.138 1.725a.625.625 0 0 0-.94-.375.645.645 0 0 0-.245.308l-2.388 6.45-.022.066a4.758 4.758 0 0 0-.122 2.908 4.6 4.6 0 0 0 1.588 2.4l.009.006.02.016 3.63 2.821 1.795 1.41 1.093.858a.719.719 0 0 0 .89 0l1.093-.858 1.795-1.41 3.65-2.837.01-.009a4.601 4.601 0 0 0 1.584-2.397 4.759 4.759 0 0 0-.12-2.904v-.003Z'
          />
          <path
            fill={fill}
            d='m18.459 8.174-.025-.063a7.907 7.907 0 0 0-3.203 1.493L10 13.712c1.781 1.4 3.332 2.615 3.332 2.615l3.65-2.838.01-.008a4.6 4.6 0 0 0 1.587-2.4 4.764 4.764 0 0 0-.12-2.907Z'
          />
          <path
            fill={fill}
            d='m6.667 16.328 1.795 1.41 1.094.858a.719.719 0 0 0 .89 0l1.092-.858 1.795-1.41s-1.552-1.22-3.334-2.615c-1.78 1.395-3.332 2.615-3.332 2.615ZM4.768 9.605a7.899 7.899 0 0 0-3.202-1.497l-.025.065a4.758 4.758 0 0 0-.12 2.907 4.6 4.6 0 0 0 1.588 2.4l.009.006.02.017 3.63 2.82L10 13.71 4.768 9.605Z'
          />
        </>
      );
    case 'bug':
      return (
        <>
          <path
            fill={fill}
            d='M10 1.25c.97 0 1.796.348 2.477 1.044.682.695 1.023 1.538 1.023 2.527h-7c0-.99.341-1.832 1.023-2.527C8.205 1.598 9.03 1.25 10 1.25Z'
          />
          <path
            fill={fill}
            d='M18.05 10.536c.189 0 .353.07.491.212a.693.693 0 0 1 .209.502c0 .194-.07.361-.208.502a.666.666 0 0 1-.492.213H15.6c0 1.272-.244 2.35-.733 3.236l2.275 2.333a.694.694 0 0 1 .208.502c0 .193-.07.36-.208.502a.644.644 0 0 1-.492.212.644.644 0 0 1-.492-.212l-2.166-2.198a2.115 2.115 0 0 1-.164.145c-.073.06-.226.165-.46.318a6.81 6.81 0 0 1-.71.407c-.241.12-.54.227-.897.324-.358.097-.711.145-1.061.145v-10H9.3v10a4.2 4.2 0 0 1-1.11-.15 4.433 4.433 0 0 1-.952-.37 9.094 9.094 0 0 1-.722-.435 3.847 3.847 0 0 1-.475-.362l-.165-.157-2.001 2.31a.693.693 0 0 1-.525.235.702.702 0 0 1-.47-.179.723.723 0 0 1-.224-.496.72.72 0 0 1 .169-.52l2.21-2.533c-.424-.848-.635-1.867-.635-3.057H1.95a.667.667 0 0 1-.492-.213.693.693 0 0 1-.208-.502c0-.193.07-.36.208-.502a.666.666 0 0 1 .492-.212H4.4V7.255L2.508 5.324A.693.693 0 0 1 2.3 4.82c0-.193.07-.36.208-.502A.666.666 0 0 1 3 4.107c.19 0 .354.07.492.212L5.384 6.25h9.231l1.892-1.93A.666.666 0 0 1 17 4.106c.19 0 .354.07.493.212a.694.694 0 0 1 .207.502c0 .194-.069.361-.207.503l-1.893 1.93v3.282h2.45Z'
          />
        </>
      );
    case 'hack':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M5 1.875c0-.345.28-.625.625-.625h.625c.345 0 .625.28.625.625V2.5H7.5c.345 0 .625.28.625.625V5h3.75V3.125c0-.345.28-.625.625-.625h.625v-.625c0-.345.28-.625.625-.625h.625c.345 0 .625.28.625.625V2.5c0 .345-.28.625-.625.625h-.625V5H15c.345 0 .625.28.625.625v2.5c0-.345.28-.625.625-.625h.625c.345 0 .625.28.625.625V10h.625c.345 0 .625.28.625.625v3.75c0 .345-.28.625-.625.625H17.5a.625.625 0 0 1-.625-.625V12.5h-.625a.625.625 0 0 1-.625-.625v1.25c0 .345-.28.625-.625.625H5a.625.625 0 0 1-.625-.625v-1.25c0 .345-.28.625-.625.625h-.625v1.875c0 .345-.28.625-.625.625h-.625a.625.625 0 0 1-.625-.625v-3.75c0-.345.28-.625.625-.625H2.5V8.125c0-.345.28-.625.625-.625h.625c.345 0 .625.28.625.625v-2.5C4.375 5.28 4.655 5 5 5h1.25V3.125h-.625A.625.625 0 0 1 5 2.5v-.625Zm1.25 6.25c0-.345.28-.625.625-.625H7.5c.345 0 .625.28.625.625v.625c0 .345-.28.625-.625.625h-.625a.625.625 0 0 1-.625-.625v-.625ZM12.5 7.5a.625.625 0 0 0-.625.625v.625c0 .345.28.625.625.625h.625c.345 0 .625-.28.625-.625v-.625a.625.625 0 0 0-.625-.625H12.5Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            d='M6.875 15a.625.625 0 0 0-.625.625v1.25h-.625A.625.625 0 0 0 5 17.5v.625c0 .345.28.625.625.625H7.5c.345 0 .625-.28.625-.625v-2.5A.625.625 0 0 0 7.5 15h-.625ZM12.5 15a.625.625 0 0 0-.625.625v2.5c0 .345.28.625.625.625h1.875c.345 0 .625-.28.625-.625V17.5a.625.625 0 0 0-.625-.625h-.625v-1.25a.625.625 0 0 0-.625-.625H12.5Z'
          />
        </>
      );
    case 'code':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M12.371 1.356a.938.938 0 0 1 .736 1.103L9.982 18.084a.938.938 0 0 1-1.839-.367l3.125-15.625a.937.937 0 0 1 1.103-.736ZM14.677 5.337A.938.938 0 0 1 16 5.39l3.75 4.062a.938.938 0 0 1 0 1.272l-3.75 4.062a.937.937 0 1 1-1.377-1.271l3.163-3.427-3.163-3.427a.938.938 0 0 1 .053-1.324ZM5.249 5.39A.938.938 0 1 1 6.626 6.66l-3.163 3.427 3.163 3.427a.938.938 0 0 1-1.377 1.271l-3.75-4.062a.938.938 0 0 1 0-1.272l3.75-4.062Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'terminal':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.66 3.298c-.41.802-.41 1.852-.41 3.952v5.5c0 2.1 0 3.15.41 3.953a3.75 3.75 0 0 0 1.638 1.638c.802.409 1.852.409 3.952.409h5.5c2.1 0 3.15 0 3.953-.409a3.749 3.749 0 0 0 1.639-1.639c.409-.802.409-1.852.409-3.952v-5.5c0-2.1 0-3.15-.41-3.952a3.75 3.75 0 0 0-1.638-1.64c-.802-.408-1.852-.408-3.952-.408h-5.5c-2.1 0-3.15 0-3.953.409a3.75 3.75 0 0 0-1.639 1.639Zm3.53 5.598a.938.938 0 1 0-1.004 1.583L7.374 12.5l-3.188 2.02a.938.938 0 0 0 1.004 1.584l4.437-2.812a.938.938 0 0 0 0-1.584L5.19 8.896Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'sentry':
      return (
        <>
          <path
            fill={fill}
            d='M11.392 3.27a1.616 1.616 0 0 0-.596-.564 1.673 1.673 0 0 0-1.61 0c-.246.135-.451.329-.597.564L6.284 7.108a11.19 11.19 0 0 1 4.353 3.736 10.77 10.77 0 0 1 1.866 5.345h-1.619a9.261 9.261 0 0 0-1.65-4.57A9.625 9.625 0 0 0 5.468 8.45l-2.134 3.587a5.555 5.555 0 0 1 2.162 1.67 5.345 5.345 0 0 1 1.072 2.475H2.85a.272.272 0 0 1-.213-.132.253.253 0 0 1-.004-.246l1.03-1.703a3.795 3.795 0 0 0-1.177-.647l-1.02 1.703a1.518 1.518 0 0 0-.16 1.183c.054.197.15.383.279.544.129.162.29.297.474.398.241.132.514.203.791.204h5.091a6.447 6.447 0 0 0-.605-3.306 6.652 6.652 0 0 0-2.198-2.59l.81-1.362a8.199 8.199 0 0 1 2.795 3.164 7.935 7.935 0 0 1 .813 4.094h4.313c.1-2.136-.377-4.261-1.386-6.162A12.353 12.353 0 0 0 8.12 6.655L9.756 3.93a.276.276 0 0 1 .368-.092c.186.1 7.109 11.843 7.239 11.98a.252.252 0 0 1-.005.259.272.272 0 0 1-.234.125h-1.667c.02.434.02.866 0 1.298h1.674a1.65 1.65 0 0 0 .62-.117 1.61 1.61 0 0 0 .527-.34 1.527 1.527 0 0 0 .255-1.89L11.393 3.27Z'
          />
        </>
      );
    case 'database':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.5 5.625v-1.25C2.5 2.649 5.858 1.25 10 1.25c4.142 0 7.5 1.4 7.5 3.125v1.25c0 1.726-3.358 3.125-7.5 3.125-4.142 0-7.5-1.4-7.5-3.125Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.5 4.375v1.25c0 .704.558 1.353 1.5 1.875.068.038.14.076.213.113C5.588 8.307 7.67 8.75 10 8.75c2.454 0 4.632-.491 6-1.25.942-.522 1.5-1.171 1.5-1.875v-1.25c0-1.726-3.358-3.125-7.5-3.125-4.142 0-7.5 1.4-7.5 3.125Zm.107 4.472c-.07.171-.107.348-.107.528v1.25c0 .704.558 1.353 1.5 1.875 1.368.759 3.546 1.25 6 1.25 2.33 0 4.412-.443 5.787-1.137.073-.037.144-.075.213-.113.942-.522 1.5-1.171 1.5-1.875v-1.25c0-.18-.037-.357-.107-.528-.426.282-.892.52-1.369.718-1.636.682-3.767 1.06-6.024 1.06s-4.388-.378-6.024-1.06a8.143 8.143 0 0 1-1.37-.718Zm0 5c-.07.171-.107.348-.107.528v1.25c0 1.726 3.358 3.125 7.5 3.125 4.142 0 7.5-1.4 7.5-3.125v-1.25c0-.18-.037-.357-.107-.528-.426.282-.892.52-1.369.719-1.636.681-3.767 1.059-6.024 1.059s-4.388-.378-6.024-1.06a8.129 8.129 0 0 1-1.37-.718Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'server':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M16.25 13.75c.69 0 1.25.56 1.25 1.25v2.5c0 .69-.56 1.25-1.25 1.25H3.75c-.69 0-1.25-.56-1.25-1.25V15c0-.69.56-1.25 1.25-1.25h12.5ZM5 15.313a.938.938 0 1 0 0 1.875.938.938 0 0 0 0-1.875ZM16.25 7.5c.69 0 1.25.56 1.25 1.25v2.5c0 .69-.56 1.25-1.25 1.25H3.75c-.69 0-1.25-.56-1.25-1.25v-2.5c0-.69.56-1.25 1.25-1.25h12.5ZM5 9.063a.938.938 0 1 0 0 1.875.938.938 0 0 0 0-1.876ZM16.25 1.25c.69 0 1.25.56 1.25 1.25V5c0 .69-.56 1.25-1.25 1.25H3.75C3.06 6.25 2.5 5.69 2.5 5V2.5c0-.69.56-1.25 1.25-1.25h12.5ZM5 2.813a.938.938 0 1 0 0 1.875.938.938 0 0 0 0-1.875Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'discord':
      return (
        <>
          <path
            fill={fill}
            d='M16.508 3.756A14.915 14.915 0 0 0 12.64 2.5c-.167.311-.362.73-.496 1.063a13.749 13.749 0 0 0-4.287 0A11.53 11.53 0 0 0 7.356 2.5c-1.359.243-2.658.67-3.871 1.26C1.036 7.582.373 11.31.705 14.985a15.284 15.284 0 0 0 4.744 2.512 12.29 12.29 0 0 0 1.016-1.729 9.87 9.87 0 0 1-1.6-.805c.134-.103.265-.21.392-.32 3.085 1.49 6.437 1.49 9.486 0 .128.11.26.217.392.32a9.84 9.84 0 0 1-1.603.807c.293.607.633 1.186 1.016 1.729a15.253 15.253 0 0 0 4.747-2.514c.39-4.26-.665-7.955-2.787-11.23Zm-9.623 8.97c-.926 0-1.685-.894-1.685-1.982s.743-1.983 1.685-1.983c.943 0 1.702.893 1.686 1.983.001 1.088-.743 1.982-1.686 1.982Zm6.23 0c-.927 0-1.686-.894-1.686-1.982s.743-1.983 1.686-1.983c.942 0 1.701.893 1.685 1.983 0 1.088-.743 1.982-1.685 1.982Z'
          />
        </>
      );
    case 'cloud':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M5.625 16.25H5v-.044a4.376 4.376 0 0 1 .152-8.68 5 5 0 0 1 9.842.974l.006.25a3.75 3.75 0 1 1 0 7.5H5.625Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'notion':
      return (
        <>
          <path
            fill={fill}
            d='M7.504 1.608c-2.851.212-5.276.397-5.386.41-.317.067-.606.265-.744.543l-.124.238.028 11.489.179.357c.11.199.799 1.125 1.556 2.065 1.502 1.88 1.612 1.972 2.177 2.038.165.013 1.419-.04 2.755-.12 1.35-.079 3.527-.21 4.822-.277 5.551-.331 5.262-.304 5.593-.57.4-.317.358.213.386-6.776.013-5.916 0-6.313-.097-6.485-.096-.212-.29-.344-2.824-2.052-1.694-1.151-1.818-1.204-2.576-1.217-.317-.014-2.907.159-5.745.357Zm6.406.754c.248.106 1.998 1.271 2.246 1.496.069.066.096.132.055.159-.07.066-10.91.688-11.228.635a1.254 1.254 0 0 1-.468-.172c-.496-.33-1.722-1.297-1.722-1.363 0-.185-.041-.185 4.78-.53.923-.052 2.452-.158 3.375-.238 1.998-.145 2.59-.145 2.962.013Zm3.444 2.992c.083.08.152.225.18.37.013.133.027 2.594.013 5.453-.014 4.897-.028 5.215-.124 5.347a.501.501 0 0 1-.262.212c-.234.093-11.585.715-11.82.649a.757.757 0 0 1-.33-.199l-.138-.132-.014-5.294c-.013-3.72 0-5.36.042-5.506a.65.65 0 0 1 .192-.291c.097-.067.772-.12 3.086-.252a430.39 430.39 0 0 0 5.58-.318c3.444-.198 3.43-.198 3.595-.04Z'
          />
          <path
            fill={fill}
            d='M14.31 7.167c-.62.04-1.171.093-1.226.132a.57.57 0 0 0-.33.424c-.014.172.04.198.66.278l.262.026v2.343c0 1.39-.014 2.303-.055 2.276-.027-.026-.827-1.217-1.79-2.62-.965-1.43-1.764-2.594-1.778-2.594-.014-.014-.634.013-1.391.066-.923.053-1.433.119-1.53.172-.165.08-.358.37-.358.556 0 .119.22.185.675.185h.248v6.724l-.4.119c-.288.08-.399.132-.454.251-.082.185-.082.344.014.344.028 0 .675-.026 1.419-.08 1.46-.079 1.626-.118 1.777-.41a.524.524 0 0 0 .096-.211c0-.013-.206-.08-.44-.133-.248-.053-.496-.119-.551-.119-.097-.026-.097-.198-.097-2.554V9.814l1.736 2.607c1.819 2.74 2.039 3.058 2.328 3.19.345.172 1.226.053 1.667-.225l.138-.08.027-7.477.303-.053c.359-.066.524-.225.524-.503 0-.172-.014-.186-.18-.172-.096 0-.688.04-1.294.066Z'
          />
        </>
      );
    case 'zapier':
      return (
        <>
          <mask
            id='a'
            width={18}
            height={18}
            x={1}
            y={1}
            maskUnits='userSpaceOnUse'
            style={{
              maskType: 'luminance'
            }}>
            <path fill='#fff' d='M18.75 1.25H1.25v17.5h17.5V1.25Z' />
          </mask>
          <g mask='url(#a)'>
            <path
              fill={fill}
              d='M10.005 1.25c.495 0 .98.043 1.454.122v5.094l3.611-3.602a8.777 8.777 0 0 1 2.063 2.057l-3.612 3.602h5.108c.08.472.121.955.121 1.449v.012c0 .494-.042.978-.121 1.449H13.52l3.613 3.601a8.777 8.777 0 0 1-2.062 2.058l-3.612-3.603v5.095c-.472.079-.958.12-1.453.122h-.012a8.912 8.912 0 0 1-1.452-.122v-5.095l-3.611 3.603a8.776 8.776 0 0 1-2.063-2.058l3.611-3.601H1.372A8.68 8.68 0 0 1 1.25 9.98v-.025c0-.129.01-.285.021-.447l.004-.049c.036-.456.097-.937.097-.937h5.107L2.868 4.921c.283-.397.599-.77.944-1.113l.002-.002c.344-.344.718-.66 1.117-.942l3.611 3.602V1.372c.473-.08.958-.121 1.453-.122h.01Zm0 6.546h-.009c-.65 0-1.272.12-1.848.335a5.24 5.24 0 0 0-.336 1.843v.008c.001.648.12 1.27.337 1.842a5.238 5.238 0 0 0 1.847.335h.009c.65 0 1.272-.119 1.847-.335a5.205 5.205 0 0 0 .336-1.842v-.008a5.2 5.2 0 0 0-.336-1.843 5.237 5.237 0 0 0-1.847-.335Z'
            />
          </g>
        </>
      );
    case 'tablet':
      return (
        <>
          <path
            fill={fill}
            d='M18.125 2.5c.345 0 .625.28.625.625v13.75c0 .345-.28.625-.625.625H1.875a.625.625 0 0 1-.625-.625V3.125c0-.345.28-.625.625-.625h16.25ZM15 4.375H3.125v11.25H15V4.375Zm1.563 4.688a.938.938 0 1 0 0 1.875.938.938 0 0 0 0-1.875Z'
          />
        </>
      );
    case 'bitcoin':
      return (
        <>
          <path
            fill={fill}
            d='M15.278 6.606c-.191-1.907-1.82-2.538-3.874-2.709l-.01-2.022a.625.625 0 0 0-.63-.622l-.34.002a.625.625 0 0 0-.62.629l.01 1.953c-.418.002-.845.013-1.27.024l-.01-1.97a.625.625 0 0 0-.629-.622l-.34.002a.625.625 0 0 0-.62.629l.01 2.021c-.344.01-.682.018-1.012.02v-.008l-1.568.008a.625.625 0 0 0-.622.628l.003.46c.002.349.29.629.64.624.273-.004.527-.005.518.005.644-.004.856.374.919.7l.016 3.017c.045 0 .103.001.169.01l-.168.001.022 4.225c-.027.206-.144.534-.594.537.01.01-.31.011-.617.01a.629.629 0 0 0-.623.53l-.106.666c-.06.38.235.725.62.723l1.334-.008c.385-.001.764.003 1.136.003l.012 2.053a.625.625 0 0 0 .628.622l.339-.002a.625.625 0 0 0 .621-.629l-.011-2.024c.436.007.858.008 1.27.005v2.038c0 .345.28.625.625.625h.34c.345 0 .625-.28.625-.625v-2.083c2.672-.17 4.54-.863 4.758-3.409.176-2.05-.78-2.958-2.299-3.319.92-.48 1.49-1.322 1.348-2.718Zm-2.193 5.738c.012 2-3.37 1.792-4.448 1.799l-.019-3.548c1.078-.005 4.456-.338 4.467 1.749Zm-.767-5.001c.01 1.82-2.811 1.623-3.709 1.629l-.017-3.218c.898-.005 3.715-.31 3.726 1.589Z'
          />
        </>
      );
    case 'computer':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.75 3.125h12.5c.345 0 .625.28.625.625v7.5c0 .345-.28.625-.625.625H3.75a.625.625 0 0 1-.625-.625v-7.5c0-.345.28-.625.625-.625Zm-2.5.625a2.5 2.5 0 0 1 2.5-2.5h12.5a2.5 2.5 0 0 1 2.5 2.5v7.5a2.5 2.5 0 0 1-2.5 2.5H3.75a2.5 2.5 0 0 1-2.5-2.5v-7.5ZM8.75 15h2.5v1.25c0 .345.28.625.625.625 1.036 0 1.875.84 1.875 1.875h-7.5c0-1.035.84-1.875 1.875-1.875.345 0 .625-.28.625-.625V15Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'design-tools':
      return (
        <>
          <path
            fill={fill}
            d='m5.356 1.655 12.848 12.848a.625.625 0 0 1 0 .884l-3.04 3.04a.625.625 0 0 1-.883 0l-2.031-2.032 1.457-1.457.093-.107a1.04 1.04 0 0 0-1.564-1.365l-1.458 1.458-1.303-1.304 1.458-1.457.093-.106a1.04 1.04 0 0 0-1.564-1.365L8.003 12.15l-1.302-1.303L8.159 9.39l.093-.106a1.04 1.04 0 0 0-1.564-1.365L5.23 9.375 3.927 8.072l1.458-1.457.093-.106a1.04 1.04 0 0 0-1.564-1.365L2.456 6.6 1.433 5.58a.625.625 0 0 1 0-.884l3.04-3.04a.625.625 0 0 1 .883 0Zm-.24 10.549 3.006 3.006-1.631 1.68c-.8.799-4.06 1.702-4.635 1.547l-.058-.024c-.344-.246.972-3.655 1.813-4.65l.095-.103 1.41-1.456Zm13.038-10.33a2.13 2.13 0 0 1 .139 2.861l-.139.152-3.265 3.36-3.012-3.01 3.264-3.363a2.131 2.131 0 0 1 3.013 0Z'
          />
        </>
      );
    case 'ai-app':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M6.875 3.125h6.25a3.75 3.75 0 0 1 3.75 3.75v6.25a3.75 3.75 0 0 1-3.75 3.75h-6.25a3.75 3.75 0 0 1-3.75-3.75v-6.25a3.75 3.75 0 0 1 3.75-3.75ZM1.25 6.875A5.625 5.625 0 0 1 6.875 1.25h6.25a5.625 5.625 0 0 1 5.625 5.625v6.25a5.625 5.625 0 0 1-5.625 5.625h-6.25a5.625 5.625 0 0 1-5.625-5.625v-6.25Zm7.554-.894-.34 1.699c-.047.236-.07.354-.13.449a.625.625 0 0 1-.205.206c-.095.058-.213.082-.45.13l-1.698.339a1.22 1.22 0 0 0 0 2.392l1.699.34c.236.047.354.07.449.129a.625.625 0 0 1 .206.206c.058.095.082.213.13.45l.339 1.698a1.22 1.22 0 0 0 2.392 0l.34-1.699c.047-.236.07-.354.129-.449a.626.626 0 0 1 .206-.206c.095-.058.213-.082.45-.13l1.698-.339a1.22 1.22 0 0 0 0-2.392l-1.699-.34c-.236-.047-.354-.07-.449-.13a.625.625 0 0 1-.206-.205c-.058-.095-.082-.213-.13-.45l-.339-1.698a1.22 1.22 0 0 0-2.392 0Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'desktop-window':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M5.151 2.5h9.698c.494 0 .92 0 1.271.029.371.03.74.097 1.094.278.53.27.96.7 1.23 1.229.18.354.247.723.277 1.094.029.35.029.777.029 1.271V13.6c0 .494 0 .92-.029 1.271-.03.371-.097.74-.277 1.094-.27.53-.7.96-1.23 1.23-.354.18-.723.247-1.094.277-.35.029-.777.029-1.271.029H5.15c-.494 0-.92 0-1.271-.029-.371-.03-.74-.097-1.094-.277-.53-.27-.96-.7-1.23-1.23-.18-.354-.247-.723-.277-1.094-.029-.35-.029-.777-.029-1.271V6.4c0-.494 0-.92.029-1.271.03-.371.097-.74.278-1.094.27-.53.7-.96 1.229-1.23.354-.18.723-.247 1.094-.277.35-.029.777-.029 1.271-.029ZM3.125 13.563V8.75h13.75v4.813c0 .54 0 .889-.022 1.155-.021.254-.056.349-.08.395a.938.938 0 0 1-.41.41c-.046.024-.14.059-.395.08-.266.021-.615.022-1.155.022H5.187c-.54 0-.889 0-1.155-.022-.254-.021-.349-.056-.395-.08a.938.938 0 0 1-.41-.41c-.023-.046-.059-.14-.08-.395a15.94 15.94 0 0 1-.022-1.155Zm.938-7.313a.938.938 0 1 0 0-1.875.938.938 0 0 0 0 1.875Zm4.062-.938a.938.938 0 1 1-1.875 0 .938.938 0 0 1 1.875 0Zm2.188.938a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.875Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'mac-os':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M7.409 6.347c.405-1.789.976-3.66 1.468-5.097H7.25c-2.1 0-3.15 0-3.952.409a3.75 3.75 0 0 0-1.64 1.639C1.25 4.1 1.25 5.15 1.25 7.25v5.5c0 2.1 0 3.15.409 3.953a3.75 3.75 0 0 0 1.639 1.638c.802.409 1.852.409 3.952.409h3.042c-.22-.625-.38-1.268-.496-1.903-1.23-.116-2.463-.575-4.224-1.283-.458-.184-.688-.726-.514-1.21.175-.484.688-.727 1.147-.542 1.558.626 2.53.979 3.365 1.118-.05-.868-.03-1.668.02-2.327H8.073a.937.937 0 0 1-.831-.504c-.369-.705-.405-1.673-.342-2.583.065-.96.258-2.062.509-3.169Zm-4.284-.41a.938.938 0 0 1 1.875 0v1.875a.938.938 0 0 1-1.875 0V5.938Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M11.687 16.757c1.08-.19 2.301-.598 3.956-1.18.465-.164.716-.694.561-1.186-.155-.49-.658-.756-1.123-.593-1.675.59-2.761.942-3.634 1.1-.081-1.28.008-2.416.121-3.074a.938.938 0 0 0-.924-1.096H8.778a6.044 6.044 0 0 1-.008-1.085c.057-.825.227-1.822.468-2.882.446-1.974 1.112-4.074 1.626-5.511h1.886c2.1 0 3.15 0 3.953.409a3.75 3.75 0 0 1 1.638 1.639c.409.802.409 1.852.409 3.952v5.5c0 2.1 0 3.15-.409 3.953a3.75 3.75 0 0 1-1.639 1.638c-.802.409-1.852.409-3.952.409h-.443a9.673 9.673 0 0 1-.62-1.993ZM15.313 5a.938.938 0 0 0-.938.938v1.875a.938.938 0 0 0 1.875 0V5.938A.937.937 0 0 0 15.312 5Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'money-stack':
      return (
        <>
          <path fill='#505556' d='M10 8.75A1.875 1.875 0 1 0 10 5a1.875 1.875 0 0 0 0 3.75Z' />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.813 1.25c-.863 0-1.563.7-1.563 1.563v8.124a1.563 1.563 0 0 0 1.5 1.563h14.5a1.563 1.563 0 0 0 1.5-1.563V2.813c0-.863-.7-1.563-1.563-1.563H2.813Zm.312 7.538a2.294 2.294 0 0 1 1.837 1.837h10.076a2.294 2.294 0 0 1 1.837-1.837V4.962a2.294 2.294 0 0 1-1.837-1.837H4.962a2.294 2.294 0 0 1-1.837 1.837v3.826Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            d='M1.25 14.375v-.625h17.5v.625c0 .69-.56 1.25-1.25 1.25h-15c-.69 0-1.25-.56-1.25-1.25ZM1.25 17.5v-.625h17.5v.625c0 .69-.56 1.25-1.25 1.25h-15c-.69 0-1.25-.56-1.25-1.25Z'
          />
        </>
      );
    case 'pills':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10.13 2.729A5.05 5.05 0 1 1 17.27 9.87l-7.4 7.401a5.05 5.05 0 1 1-7.142-7.141l7.4-7.401ZM8.006 7.504a4.726 4.726 0 0 1 3.12 1.341 4.53 4.53 0 0 1 1.373 3.146l3.446-3.447a3.175 3.175 0 0 0-4.49-4.49l-3.449 3.45Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'megaphone':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='m2.587 4.971 10.586-3.529a3.75 3.75 0 0 1 1.186-.192h.017c2.416 0 4.375 2.798 4.375 6.25s-1.96 6.25-4.375 6.25h-.214a3.76 3.76 0 0 1-.813-.09l-10.74-2.386a.366.366 0 0 1-.185-.104C.79 9.47.804 6.767 2.437 5.066a.37.37 0 0 1 .15-.095Zm11.789 6.904c1.38 0 2.5-1.959 2.5-4.375s-1.12-4.375-2.5-4.375c-1.381 0-2.5 1.959-2.5 4.375s1.119 4.375 2.5 4.375Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            d='m3.75 13.125 1.032 4.646a1.25 1.25 0 0 0 1.22.979h.248c.69 0 1.25-.56 1.25-1.25v-3.75l-3.75-.625ZM15.313 7.5c0 .863-.42 1.563-.938 1.563s-.938-.7-.938-1.563.42-1.563.938-1.563.938.7.938 1.563Z'
          />
        </>
      );
    case 'sign':
      return (
        <>
          <path
            fill={fill}
            d='M8.75 15.875a.25.25 0 0 1 .25-.25h2a.25.25 0 0 1 .25.25v2.25c0 .69-.56.625-1.25.625s-1.25.065-1.25-.625v-2.25ZM8.75 1.874c0-.634.473-.63 1.085-.625h.33c.613-.005 1.085-.009 1.085.625v1a.25.25 0 0 1-.25.25H9a.25.25 0 0 1-.25-.25v-1ZM16.251 14.2c0 .28 0 .42-.054.527a.5.5 0 0 1-.219.218c-.107.055-.247.055-.527.055H4.061c-.115 0-.172 0-.226-.012a.498.498 0 0 1-.137-.053c-.049-.028-.09-.066-.176-.143l-1.87-1.7c-.225-.205-.338-.308-.38-.428a.5.5 0 0 1 0-.328c.042-.12.155-.223.38-.428l1.87-1.7c.085-.077.127-.115.176-.143a.5.5 0 0 1 .137-.053C3.889 10 3.946 10 4.06 10h11.39c.28 0 .42 0 .527.055a.5.5 0 0 1 .219.218c.054.107.054.247.054.527v3.4ZM3.804 4.023c-.054.107-.054.247-.054.527v3.4c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218c.107.055.247.055.527.055h11.39c.115 0 .172 0 .226-.012a.5.5 0 0 0 .138-.053c.048-.028.09-.066.175-.143l1.87-1.7c.226-.205.338-.308.38-.428a.498.498 0 0 0 0-.328c-.041-.12-.154-.223-.38-.428l-1.87-1.7a1.065 1.065 0 0 0-.175-.143.5.5 0 0 0-.137-.053c-.055-.012-.112-.012-.226-.012H4.55c-.28 0-.42 0-.527.054a.5.5 0 0 0-.219.219Z'
          />
        </>
      );
    case 'dashboard':
      return (
        <>
          <path
            fill={fill}
            d='M5.938 7.5A.937.937 0 0 0 5 8.438v2.5a.937.937 0 0 0 1.875 0v-2.5a.937.937 0 0 0-.938-.938ZM8.75 5.937a.937.937 0 1 1 1.875 0v5a.938.938 0 0 1-1.875 0v-5Zm5.313.313a.937.937 0 0 0-.938.938v3.75a.938.938 0 0 0 1.875 0v-3.75a.938.938 0 0 0-.938-.938Z'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.59 2.956c-.34.669-.34 1.544-.34 3.294v4.375c0 1.75 0 2.625.34 3.294.3.588.778 1.065 1.366 1.365.669.341 1.544.341 3.294.341h7.5c1.75 0 2.625 0 3.294-.341a3.126 3.126 0 0 0 1.365-1.365c.341-.669.341-1.544.341-3.294V6.25c0-1.75 0-2.625-.341-3.294a3.126 3.126 0 0 0-1.365-1.366c-.669-.34-1.544-.34-3.294-.34h-7.5c-1.75 0-2.625 0-3.294.34-.588.3-1.066.778-1.366 1.366Zm12.16.169h-7.5c-.906 0-1.473.001-1.9.038-.405.032-.516.085-.542.098a1.25 1.25 0 0 0-.547.546c-.012.026-.066.138-.1.543-.035.428-.036.994-.036 1.9v4.375c0 .906.001 1.473.038 1.9.032.405.085.516.098.543.12.235.311.426.546.546.026.012.138.066.543.1.428.035.994.036 1.9.036h7.5c.906 0 1.473-.001 1.9-.037.405-.033.516-.087.542-.1a1.25 1.25 0 0 0 .547-.545c.012-.025.066-.138.1-.543.035-.428.036-.994.036-1.9V6.25c0-.906-.001-1.473-.038-1.9-.032-.405-.086-.516-.098-.542a1.25 1.25 0 0 0-.547-.547c-.024-.012-.137-.066-.542-.1-.428-.035-.994-.036-1.9-.036Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            d='M5 17.813a.937.937 0 0 1 .938-.938h8.125a.938.938 0 0 1 0 1.875H5.937A.938.938 0 0 1 5 17.812Z'
          />
        </>
      );
    case 'pie-chart':
      return (
        <>
          <path
            fill={fill}
            d='M11.87 1.345c-.682-.105-1.245.465-1.245 1.155v5.625c0 .69.56 1.25 1.25 1.25H17.5c.69 0 1.26-.563 1.155-1.245a8.131 8.131 0 0 0-6.785-6.785Z'
          />
          <path
            fill={fill}
            d='M18.34 12.654c.23-.725-.36-1.404-1.12-1.404H10c-.69 0-1.25-.56-1.25-1.25V2.78c0-.76-.679-1.35-1.404-1.12A8.75 8.75 0 1 0 18.34 12.654Z'
          />
        </>
      );
    case 'bar-chart':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.75 12.5c.69 0 1.25.56 1.25 1.25v3.75c0 .69-.56 1.25-1.25 1.25H2.5c-.69 0-1.25-.56-1.25-1.25v-3.75c0-.69.56-1.25 1.25-1.25h1.25ZM17.5 1.25c.69 0 1.25.56 1.25 1.25v15c0 .69-.56 1.25-1.25 1.25h-1.25c-.69 0-1.25-.56-1.25-1.25v-15c0-.69.56-1.25 1.25-1.25h1.25Zm-6.875 5c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25h-1.25c-.69 0-1.25-.56-1.25-1.25v-10c0-.69.56-1.25 1.25-1.25h1.25Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'chart':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.25 2.5c0-.69.56-1.25 1.25-1.25h15c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25h-15c-.69 0-1.25-.56-1.25-1.25v-10Zm12.457 1.25a.5.5 0 0 0-.354.854l.359.358-2.358 2.359a.313.313 0 0 1-.409.029l-.836-.627a2.187 2.187 0 0 0-2.725.08L4.082 9.597a.938.938 0 0 0 1.211 1.431l3.302-2.794a.312.312 0 0 1 .39-.011l.835.627c.871.653 2.09.566 2.86-.204l2.358-2.358.358.358a.5.5 0 0 0 .854-.353V4.25a.5.5 0 0 0-.5-.5h-2.043Z'
            clipRule='evenodd'
          />
          <path fill={fill} d='M8.75 15v1.982A1.876 1.876 0 0 0 7.5 18.75h5c0-.816-.522-1.51-1.25-1.768V15h-2.5Z' />
        </>
      );
    case 'subscribe':
      return (
        <>
          <path
            fill={fill}
            d='M7.5 16.25h5a2.5 2.5 0 0 1-4.994.188L7.5 16.25Zm2.5-15a5 5 0 0 1 5 5v3.787l2.105 1.973a1.249 1.249 0 0 1 .395.912v.828A1.25 1.25 0 0 1 16.25 15H3.75a1.25 1.25 0 0 1-1.25-1.25v-.828a1.25 1.25 0 0 1 .395-.912L5 10.037V6.25a5 5 0 0 1 5-5Z'
          />
        </>
      );
    case 'figma':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M4.375 5.002c0 1.023.49 1.93 1.25 2.5a3.12 3.12 0 0 0-1.25 2.5c0 1.023.49 1.93 1.25 2.5a3.125 3.125 0 1 0 5 2.5v-2.5a3.125 3.125 0 0 0 3.75-5A3.125 3.125 0 0 0 12.5 1.877h-5a3.125 3.125 0 0 0-3.125 3.125ZM12.5 6.877a1.875 1.875 0 0 0 0-3.75h-1.875v3.75H12.5Zm-1.875 3.125a1.875 1.875 0 1 0 3.75 0 1.875 1.875 0 0 0-3.75 0Zm-1.25 1.875H7.5a1.875 1.875 0 1 1 0-3.75h1.875v3.75ZM7.5 13.127h1.875v1.875A1.875 1.875 0 1 1 7.5 13.127Zm1.875-6.25H7.5a1.875 1.875 0 1 1 0-3.75h1.875v3.75Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'chip':
      return (
        <>
          {' '}
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10.95 6.875h-1.9c-.756 0-1.206.002-1.54.03-.16.013-.247.03-.287.04a.161.161 0 0 0-.044.018.625.625 0 0 0-.216.216.161.161 0 0 0-.018.044c-.01.04-.027.127-.04.288-.028.333-.03.783-.03 1.539v1.9c0 .756.002 1.206.03 1.54.013.16.03.247.04.287.004.016.01.03.018.044a.625.625 0 0 0 .216.216.157.157 0 0 0 .044.018c.04.01.127.027.288.04.333.028.783.03 1.539.03h1.9c.756 0 1.206-.002 1.54-.03.16-.013.247-.03.287-.04a.157.157 0 0 0 .044-.018.625.625 0 0 0 .216-.216.157.157 0 0 0 .018-.044c.01-.04.027-.127.04-.288.028-.333.03-.783.03-1.539v-1.9c0-.756-.002-1.206-.03-1.54a1.908 1.908 0 0 0-.04-.287.157.157 0 0 0-.018-.044.625.625 0 0 0-.216-.216.16.16 0 0 0-.044-.018 1.906 1.906 0 0 0-.288-.04c-.333-.028-.783-.03-1.539-.03ZM5.29 6.33C5 6.88 5 7.603 5 9.05v1.9c0 1.447 0 2.171.29 2.72a2.5 2.5 0 0 0 1.04 1.04c.549.29 1.273.29 2.72.29h1.9c1.447 0 2.171 0 2.72-.29a2.5 2.5 0 0 0 1.04-1.04c.29-.549.29-1.273.29-2.72v-1.9c0-1.447 0-2.171-.29-2.72a2.5 2.5 0 0 0-1.04-1.04C13.12 5 12.397 5 10.95 5h-1.9c-1.447 0-2.171 0-2.72.29a2.5 2.5 0 0 0-1.04 1.04Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M17.813 7.188H14a.25.25 0 0 1-.25-.25V5.563a.25.25 0 0 1 .25-.25h3.813a.937.937 0 1 1 0 1.875ZM17.813 14.688H14a.25.25 0 0 1-.25-.25v-1.376a.25.25 0 0 1 .25-.25h3.813a.938.938 0 0 1 0 1.876ZM17.813 10.938H14a.25.25 0 0 1-.25-.25V9.312a.25.25 0 0 1 .25-.25h3.813a.937.937 0 1 1 0 1.876Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M12.813 17.813V14a.25.25 0 0 1 .25-.25h1.374a.25.25 0 0 1 .25.25v3.813a.937.937 0 1 1-1.874 0ZM5.313 17.813V14a.25.25 0 0 1 .25-.25h1.375a.25.25 0 0 1 .25.25v3.813a.937.937 0 1 1-1.875 0ZM9.063 17.813V14a.25.25 0 0 1 .25-.25h1.374a.25.25 0 0 1 .25.25v3.813a.937.937 0 1 1-1.874 0ZM7.188 2.188V6a.25.25 0 0 1-.25.25H5.563a.25.25 0 0 1-.25-.25V2.187a.938.938 0 0 1 1.875 0ZM14.688 2.188V6a.25.25 0 0 1-.25.25h-1.376a.25.25 0 0 1-.25-.25V2.187a.938.938 0 0 1 1.876 0ZM10.938 2.188V6a.25.25 0 0 1-.25.25H9.312a.25.25 0 0 1-.25-.25V2.187a.938.938 0 0 1 1.876 0Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.188 12.813H6a.25.25 0 0 1 .25.25v1.374a.25.25 0 0 1-.25.25H2.187a.937.937 0 1 1 0-1.874ZM2.188 5.313H6a.25.25 0 0 1 .25.25v1.375a.25.25 0 0 1-.25.25H2.187a.938.938 0 0 1 0-1.875ZM2.188 9.063H6a.25.25 0 0 1 .25.25v1.374a.25.25 0 0 1-.25.25H2.187a.937.937 0 1 1 0-1.874Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            d='M8.75 9.375c0-.345.28-.625.625-.625h1.25c.345 0 .625.28.625.625v1.25c0 .345-.28.625-.625.625h-1.25a.625.625 0 0 1-.625-.625v-1.25Z'
          />
        </>
      );
    case 'battery':
      return (
        <>
          <path
            fill={fill}
            d='M4.516 7.549c-.141.27-.141.627-.141 1.338v2.226c0 .711 0 1.067.14 1.338.12.229.305.415.534.533.27.141.627.141 1.338.141h.488v-6.25h-.488c-.711 0-1.067 0-1.338.14a1.25 1.25 0 0 0-.533.534ZM14.375 11.113c0 .711 0 1.067-.14 1.338a1.251 1.251 0 0 1-.534.533c-.27.141-.627.141-1.338.141h-.488v-6.25h.488c.711 0 1.067 0 1.338.14.229.12.415.305.533.534.141.27.141.627.141 1.338v2.226ZM10.625 6.875h-2.5v6.25h2.5v-6.25Z'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.659 5.798C1.25 6.6 1.25 7.65 1.25 9.75v.5c0 2.1 0 3.15.409 3.953a3.75 3.75 0 0 0 1.638 1.638c.803.409 1.853.409 3.953.409h4.25c2.1 0 3.15 0 3.953-.409a3.75 3.75 0 0 0 1.638-1.638c.227-.446.328-.968.373-1.703h.036c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25h-.036c-.045-.735-.146-1.257-.373-1.702a3.75 3.75 0 0 0-1.639-1.64C14.65 3.75 13.6 3.75 11.5 3.75H7.25c-2.1 0-3.15 0-3.953.409A3.75 3.75 0 0 0 1.66 5.798Zm9.841-.173H7.25c-1.081 0-1.779.001-2.31.045-.51.041-.699.112-.791.16-.353.18-.64.466-.82.819-.047.092-.117.281-.16.79-.043.532-.044 1.23-.044 2.311v.5c0 1.081.001 1.78.045 2.31.042.51.112.698.16.791.18.353.466.64.819.82.092.047.281.118.79.16.532.043 1.23.044 2.311.044h4.25c1.081 0 1.779-.002 2.31-.045.51-.041.698-.112.791-.16.353-.18.64-.466.82-.819.047-.093.118-.281.16-.79.043-.532.044-1.23.044-2.311v-.5c0-1.081-.002-1.78-.045-2.31-.041-.51-.112-.699-.16-.791a1.874 1.874 0 0 0-.819-.82c-.093-.047-.281-.118-.79-.16-.532-.043-1.23-.044-2.311-.044Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'compass':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10 1.25a8.75 8.75 0 1 1 0 17.5 8.75 8.75 0 0 1 0-17.5ZM8.232 8.232c-2.093 3.8-2.977 5.862-2.652 6.187.488.489 6.187-2.651 6.187-2.651s3.14-5.7 2.652-6.187c-.325-.326-2.388.558-6.187 2.651Zm1.768.83a.937.937 0 1 1 0 1.875.937.937 0 0 1 0-1.874Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'apple':
      return (
        <>
          <path
            fill={fill}
            d='M17.507 14.888a9.421 9.421 0 0 1-.979 1.692c-.514.705-.935 1.193-1.26 1.465-.503.444-1.042.672-1.62.685-.414 0-.914-.113-1.496-.343-.583-.23-1.12-.343-1.61-.343-.515 0-1.067.114-1.657.343-.591.23-1.067.35-1.431.362-.554.022-1.106-.212-1.657-.704-.351-.296-.79-.801-1.318-1.517-.565-.765-1.03-1.652-1.394-2.663-.39-1.092-.585-2.15-.585-3.173 0-1.173.264-2.185.791-3.032A4.555 4.555 0 0 1 4.95 6.047a4.592 4.592 0 0 1 2.24-.608c.44 0 1.017.131 1.733.388.715.258 1.174.39 1.375.39.15 0 .66-.154 1.524-.459.818-.283 1.507-.4 2.072-.354 1.531.12 2.681.7 3.447 1.745-1.37.798-2.047 1.916-2.034 3.35.013 1.116.434 2.045 1.262 2.783.375.342.794.607 1.26.795-.101.282-.208.552-.321.811ZM13.995 1.6c0 .876-.332 1.693-.995 2.45-.8.898-1.767 1.418-2.816 1.336a2.634 2.634 0 0 1-.021-.332c0-.84.38-1.74 1.056-2.474a4.055 4.055 0 0 1 1.286-.929c.519-.243 1.01-.378 1.471-.4.014.116.02.233.02.35Z'
          />
        </>
      );
    case 'bucket':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10 1.25c4.142 0 7.5 1.948 7.5 4.352 0 .21-.026.418-.076.62l.001.001-2.451 9.823a.623.623 0 0 1-.111.23C13.589 17.924 11.968 18.75 10 18.75c-1.968 0-3.585-.825-4.85-2.476a.623.623 0 0 1-.084-.146l-.026-.08-2.443-9.744a2.6 2.6 0 0 1-.097-.702C2.5 3.198 5.858 1.25 10 1.25Zm0 1.243c-3.28 0-5.938 1.392-5.938 3.109C4.063 7.318 6.721 8.71 10 8.71c3.28 0 5.938-1.392 5.938-3.108 0-1.717-2.659-3.109-5.938-3.109Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'home':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.904 7.1a1.25 1.25 0 0 0-.404.919v10.104a.625.625 0 0 0 .625.625h3.75a.625.625 0 0 0 .625-.625v-4.394a2.5 2.5 0 0 1 5 0v4.394a.624.624 0 0 0 .625.625h3.75a.625.625 0 0 0 .625-.625V8.02a1.25 1.25 0 0 0-.404-.921L11.27 1.745a1.875 1.875 0 0 0-2.538 0L2.904 7.1Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'feather':
      return (
        <>
          <path
            fill={fill}
            d='M7.5 8.747s-.75-.75 1.25-3.75c1.936-2.903 7.15-3.7 9.75-3.747.138-.003.25.11.257.247.008.155.021.318.036.492.101 1.226.244 2.947-1.293 5.508-1.704 2.53-4.872 3.702-5.032 3.761l-.007.003.04-.014c2.765-.922 3.831.197 4.45.847.221.231.385.403.55.403-3.298 1.94-6.916 3.06-10.001 1.253.387-1.024 4.375-6.25 7.5-8.753-4.375 1.253-7.5 5.625-8.75 7.5-2.065-2.532-.677-7.453.625-8.747.09-.09.22.01.178.132C6.607 5.2 6.25 8.75 7.5 8.747ZM1.25 18.747H2.5l4.375-3.75-.46-.23A5.448 5.448 0 0 1 5 13.748l-3.75 5Z'
          />
        </>
      );
    case 'ship':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='m8.75 3.504-1.25.25c0-.824.174-1.64.51-2.392l.023-.052a.1.1 0 0 1 .184 0l.125.28c.27.603.408 1.255.408 1.914Zm-2.5 5.25c0-1.5-1.667-3.125-2.5-3.75l8.75-1.25.032.01c.64.213 1.976.657 2.468 3.115.375 1.875-.625 4.167-1.25 4.375l-10 1.875c.833-.625 2.5-2.5 2.5-4.375Zm-4.478 6.163a.625.625 0 0 0-.522.616v.72a2.5 2.5 0 0 0 2.5 2.5h7.5a7.5 7.5 0 0 0 7.5-7.5v-1.25l-.625-1.25a.625.625 0 0 0 0-1.25h-.077a.702.702 0 0 0-.68.533l-.323 1.287a5 5 0 0 1-4.029 3.72L1.772 14.917Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'direction':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10.567 6.511a.797.797 0 0 1 1.202 0l1.7 1.87c.332.365.332.957 0 1.323l-1.7 1.87a.797.797 0 0 1-1.202 0 1.003 1.003 0 0 1 0-1.323l.248-.273H9.467c-.156 0-.283.14-.283.311v2.494c0 .516-.38.935-.85.935s-.85-.419-.85-.935v-2.494c0-1.205.888-2.182 1.983-2.182h1.348l-.248-.274a1.002 1.002 0 0 1 0-1.322Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M11.984 2.072a2.805 2.805 0 0 0-3.968 0L2.072 8.016a2.805 2.805 0 0 0 0 3.968l5.944 5.944a2.805 2.805 0 0 0 3.968 0l5.944-5.944a2.805 2.805 0 0 0 0-3.968l-5.944-5.944ZM9.339 3.394a.935.935 0 0 1 1.322 0l5.945 5.945a.935.935 0 0 1 0 1.322l-5.945 5.945a.935.935 0 0 1-1.322 0L3.394 10.66a.935.935 0 0 1 0-1.322L9.34 3.394Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'cookie':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10.01 2.4c0-.645-.412-1.236-1.047-1.14-2.47.374-7.713 1.959-7.713 8.686 0 4.863 3.922 8.804 8.76 8.804 4.628 0 8.418-3.606 8.739-8.175a.595.595 0 0 0-.604-.629 3.137 3.137 0 0 1-3.129-3.144c0-.406-.348-.755-.745-.684a3.055 3.055 0 0 1-.506.055c-2.074 0-3.755-1.689-3.755-3.773ZM6.25 7.187a.938.938 0 1 1-1.875 0 .938.938 0 0 1 1.875 0Zm8.438 7.188a.938.938 0 1 0 0-1.875.938.938 0 0 0 0 1.875ZM11.25 9.687a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.875 0Zm-4.063 4.688a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.875Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'crane':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M18.75 6.25v.625c0 .345-.28.625-.625.625H17.5v5h-1.25v-5H8.571l.625 8.75H5.804l.625-8.75H3.75v.625c0 .345-.28.625-.625.625h-1.25a.625.625 0 0 1-.625-.625V5l5.716-3.702a.925.925 0 0 1 .89-.064L18.75 6.25Zm-4.182-.522L8.237 2.812 8.393 5h.357l5.818.728ZM3.488 5h3.12l.146-2.055L3.487 5Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            d='M6.288 18.75H3.75v-.625c0-.345.28-.625.625-.625h6.25c.345 0 .625.28.625.625v.625H6.288ZM17.396 13.75h-1.043a.25.25 0 0 0-.176.073l-1.104 1.104a.25.25 0 0 0-.073.177V16c0 .138.112.25.25.25h3.25a.25.25 0 0 0 .25-.25v-.896a.25.25 0 0 0-.073-.177l-1.104-1.104a.25.25 0 0 0-.177-.073Z'
          />
        </>
      );
    case 'dumbbell':
      return (
        <>
          <path
            fill={fill}
            d='M3.75 3.75c-.69 0-1.25.56-1.25 1.25v2.5c-.69 0-1.25.56-1.25 1.25v2.5c0 .69.56 1.25 1.25 1.25V15c0 .69.56 1.25 1.25 1.25H5c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H3.75ZM15 3.75c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h1.25c.69 0 1.25-.56 1.25-1.25v-2.5c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H15ZM12.5 8.75h-5v2.5h5v-2.5Z'
          />
        </>
      );
    case 'extinguisher':
      return (
        <>
          <path
            fill={fill}
            d='M8.125 4.387a4.063 4.063 0 0 0-3.75 4.05v7.5a.937.937 0 1 1-1.875 0v-7.5a5.938 5.938 0 0 1 5.73-5.933 1.876 1.876 0 0 1 3.643.53l4.595-1.733c.494-.186 1.032.157 1.032.66V5.54c0 .502-.538.845-1.032.659l-4.593-1.733v1.036A3.748 3.748 0 0 1 13.75 8.75v4.375h-7.5V8.75c0-1.388.754-2.6 1.875-3.248V4.387ZM6.25 18.125V16.25h7.5v1.875c0 .345-.28.625-.625.625h-6.25a.625.625 0 0 1-.625-.625Z'
          />
        </>
      );
    case 'factory':
      return (
        <>
          <path
            fill={fill}
            d='M3.07 1.25a.632.632 0 0 0-.636.58l-.14 1.92h2.911l-.14-1.92a.632.632 0 0 0-.634-.58H3.069ZM5.296 5H2.204l-.952 13.08a.63.63 0 0 0 .635.67h3.726a.63.63 0 0 0 .635-.67L5.296 5ZM7.5 10.527V12.5h11.25V8.106c0-.539-.673-.809-1.067-.428L15 10.277v-2.17c0-.54-.673-.81-1.067-.429l-2.683 2.599v-2.17c0-.54-.673-.81-1.067-.429l-2.5 2.421a.596.596 0 0 0-.183.428ZM7.5 18.145V13.75h11.25v4.395c0 .334-.28.605-.625.605h-10a.615.615 0 0 1-.625-.605Z'
          />
        </>
      );
    case 'military-truck':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.5 4.7a3.031 3.031 0 0 1 2.757-3.019 52.394 52.394 0 0 1 9.486 0A3.031 3.031 0 0 1 17.5 4.7v1.55h.625c.345 0 .625.28.625.625v2.5c0 .345-.28.625-.625.625H17.5v5.25c0 .35 0 .525-.068.659a.625.625 0 0 1-.244.257v1.584c0 .35 0 .525-.069.659a.624.624 0 0 1-.273.273c-.134.068-.308.068-.659.068h-1.125c-.35 0-.524 0-.658-.068a.624.624 0 0 1-.273-.273c-.069-.134-.069-.309-.069-.659v-1.5H5.938v1.5c0 .35 0 .525-.069.659a.624.624 0 0 1-.273.273c-.133.068-.308.068-.659.068H3.813c-.35 0-.525 0-.658-.068a.624.624 0 0 1-.273-.273c-.068-.134-.068-.309-.068-.659v-1.584a.625.625 0 0 1-.245-.257C2.5 15.775 2.5 15.6 2.5 15.25V10h-.625a.625.625 0 0 1-.625-.625v-2.5c0-.345.28-.625.625-.625H2.5V4.7ZM5 7.5c0-.69.56-1.25 1.25-1.25h7.5c.69 0 1.25.56 1.25 1.25v1.875c0 .345-.28.625-.625.625h-8.75A.625.625 0 0 1 5 9.375V7.5Zm-.313 6.875a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.875Zm11.563-.937a.938.938 0 1 1-1.875 0 .938.938 0 0 1 1.875 0ZM7.812 12.5a.312.312 0 0 0-.312.313v.625c0 .172.14.312.313.312h4.375c.172 0 .312-.14.312-.312v-.625a.312.312 0 0 0-.313-.313H7.814Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'pointer':
      return (
        <>
          <path
            fill={fill}
            d='m3.531 2.552 11.246 4.326a.757.757 0 0 1 .264 1.242l-2.362 2.416 4.673 5.072a.757.757 0 0 1-.074.986l-.684.684a.757.757 0 0 1-.986.074l-5.072-4.673L8.12 15.04a.757.757 0 0 1-1.242-.264L2.552 3.531a.757.757 0 0 1 .98-.979Z'
          />
        </>
      );
    case 'safety-kit':
      return (
        <>
          <path
            fill={fill}
            d='M8.438 3.125a.312.312 0 0 0-.313.313V5H6.25V3.437c0-1.208.98-2.187 2.188-2.187h3.124c1.209 0 2.188.98 2.188 2.188V5h-1.875V3.437a.312.312 0 0 0-.313-.312H8.438Z'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.25 9.063A2.813 2.813 0 0 1 4.063 6.25h11.875a2.813 2.813 0 0 1 2.812 2.813v6.874a2.813 2.813 0 0 1-2.813 2.813H4.063a2.813 2.813 0 0 1-2.813-2.813V9.064Zm7.5.687c0-.35 0-.525.068-.659a.625.625 0 0 1 .273-.273c.134-.068.309-.068.659-.068h.5c.35 0 .525 0 .659.068.117.06.213.156.273.273.068.134.068.309.068.659v1.5h1.5c.35 0 .525 0 .659.068.117.06.213.156.273.273.068.134.068.309.068.659v.5c0 .35 0 .525-.068.659a.625.625 0 0 1-.273.273c-.134.068-.309.068-.659.068h-1.5v1.5c0 .35 0 .525-.068.659a.625.625 0 0 1-.273.273c-.134.068-.309.068-.659.068h-.5c-.35 0-.525 0-.659-.068a.625.625 0 0 1-.273-.273c-.068-.134-.068-.309-.068-.659v-1.5h-1.5c-.35 0-.525 0-.659-.068a.625.625 0 0 1-.273-.273c-.068-.134-.068-.309-.068-.659v-.5c0-.35 0-.525.068-.659a.625.625 0 0 1 .273-.273c.134-.068.309-.068.659-.068h1.5v-1.5Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'tower':
      return (
        <>
          <path
            fill={fill}
            d='M5 1.875c0-.345.28-.625.625-.625h.625c.345 0 .625.28.625.625v1.25c0 .345.28.625.625.625h.625c.345 0 .625-.28.625-.625v-1.25c0-.345.28-.625.625-.625h1.25c.345 0 .625.28.625.625v1.25c0 .345.28.625.625.625h.625c.345 0 .625-.28.625-.625v-1.25c0-.345.28-.625.625-.625h.625c.345 0 .625.28.625.625V5a3.75 3.75 0 0 1-2.257 3.44l.73 6.56H6.527l.729-6.56A3.75 3.75 0 0 1 5 5V1.875ZM5 16.25c-.69 0-1.25.56-1.25 1.25v.625c0 .345.28.625.625.625h11.25c.345 0 .625-.28.625-.625V17.5c0-.69-.56-1.25-1.25-1.25H5Z'
          />
        </>
      );
    case 'brick':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.75 3.75c0-.345.28-.625.625-.625h3.75c.345 0 .625.28.625.625V5h2.5V3.75c0-.345.28-.625.625-.625h3.75c.345 0 .625.28.625.625V5h.938c.863 0 1.562.7 1.562 1.563v9.375c0 .862-.7 1.562-1.563 1.562H2.813c-.862 0-1.562-.7-1.562-1.563V6.563C1.25 5.7 1.95 5 2.813 5h.937V3.75Zm-.625 3.125v8.75h13.75v-8.75H3.125Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'spreadsheet':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M16.25 2.5a2.5 2.5 0 0 1 2.5 2.5v10a2.5 2.5 0 0 1-2.5 2.5H3.75a2.5 2.5 0 0 1-2.5-2.5V5a2.5 2.5 0 0 1 2.5-2.5h12.5Zm-9.375 5v3.125h3.75V7.5h-3.75Zm5.625 8.125h3.75c.345 0 .625-.28.625-.625v-2.5H12.5v3.125ZM10.625 12.5v3.125h-3.75V12.5h3.75Zm1.875-1.875h4.375V7.5H12.5v3.125Zm-9.375 0H5V7.5H3.125v3.125Zm.625 5H5V12.5H3.125V15c0 .345.28.625.625.625Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'project':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='m14.909 16.54-1.693.975c-1.171.675-1.757 1.013-2.38 1.146a4.022 4.022 0 0 1-1.672 0c-.623-.133-1.209-.47-2.38-1.146L5.09 16.54c-1.171-.677-1.757-1.014-2.183-1.488a4.015 4.015 0 0 1-.837-1.446c-.196-.605-.196-1.28-.196-2.631v-1.95c0-1.353 0-2.028.196-2.633a4.01 4.01 0 0 1 .838-1.446c.425-.474 1.011-.811 2.182-1.488l1.693-.975c1.171-.675 1.757-1.013 2.38-1.146a4.025 4.025 0 0 1 1.672 0c.623.133 1.209.47 2.38 1.146l1.693.975c1.171.677 1.757 1.014 2.184 1.488.376.417.662.91.836 1.446.196.605.196 1.28.196 2.633v1.95c0 1.352 0 2.027-.196 2.632a4.01 4.01 0 0 1-.838 1.446c-.425.474-1.011.81-2.182 1.487Zm-7.189-.65-1.691-.975c-1.282-.74-1.549-.918-1.729-1.118a2.14 2.14 0 0 1-.445-.771c-.084-.255-.105-.574-.105-2.051v-1.95c0-.473.002-.827.007-1.098l3.777 1.888a2.813 2.813 0 0 1 1.53 2.502v4.321a28.935 28.935 0 0 1-1.344-.746v-.002Zm3.219.746c.265-.131.665-.355 1.341-.745l1.691-.975c1.283-.74 1.549-.919 1.729-1.119.2-.222.352-.486.445-.771.082-.255.105-.574.105-2.053V9.025c0-.473-.003-.827-.008-1.098l-3.75 1.875-.008.004a2.812 2.812 0 0 0-1.545 2.511v4.32-.001Zm4.696-10.503-3.98 1.99-.012.005-.384.193a2.812 2.812 0 0 1-2.517 0L8.38 8.14l-.033-.017-3.982-1.99c.188-.18.525-.395 1.662-1.05l1.693-.976c1.281-.74 1.57-.881 1.834-.937.293-.063.598-.063.892 0 .264.056.553.197 1.834.937l1.691.975c1.14.656 1.476.873 1.664 1.051Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'robot':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M11.25 2.5c0 .463-.251.867-.625 1.083v.792c0 .345.28.625.625.625h.625c1.747 0 2.62 0 3.31.286a3.75 3.75 0 0 1 2.03 2.03c.285.688.285 1.562.285 3.31 0 1.747 0 2.62-.285 3.31a3.75 3.75 0 0 1-2.03 2.029c-.543.225-1.201.273-2.311.282a.377.377 0 0 0-.374.377v.501c0 .207.168.375.375.375h.25c.345 0 .625.28.625.625v.375a.25.25 0 0 1-.25.25h-7a.25.25 0 0 1-.25-.25v-.375c0-.345.28-.625.625-.625h.25a.375.375 0 0 0 .375-.375v-.502a.377.377 0 0 0-.374-.376c-1.11-.01-1.768-.057-2.311-.282a3.75 3.75 0 0 1-2.03-2.03c-.285-.689-.285-1.563-.285-3.31s0-2.62.285-3.31a3.75 3.75 0 0 1 2.03-2.03C5.505 5 6.378 5 8.125 5h.625c.345 0 .625-.28.625-.625v-.792A1.25 1.25 0 1 1 11.25 2.5Zm-5 7.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM15 8.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm-7 2.5a.5.5 0 0 0-.5.5v.875a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-.875a.5.5 0 0 0-.5-.5H8Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'checklist':
      return (
        <>
          <path
            fill={fill}
            d='M8.481 1.625a.937.937 0 0 1-.012 1.326L5.467 5.9a1.563 1.563 0 0 1-2.183.006l-1.75-1.7A.938.938 0 1 1 2.84 2.861l1.53 1.488 2.785-2.737a.937.937 0 0 1 1.325.013Zm2.769 1.907a.938.938 0 0 1 .937-.937h5.625a.938.938 0 0 1 0 1.875h-5.625a.938.938 0 0 1-.937-.938ZM8.48 7.875a.937.937 0 0 1-.012 1.326L5.467 12.15a1.563 1.563 0 0 1-2.183.006l-1.75-1.7A.938.938 0 1 1 2.84 9.111l1.53 1.488 2.785-2.737a.937.937 0 0 1 1.325.013Zm2.769 1.907a.938.938 0 0 1 .937-.937h5.625a.938.938 0 0 1 0 1.875h-5.625a.938.938 0 0 1-.937-.938Zm-2.781 5.67a.937.937 0 1 0-1.313-1.338l-2.785 2.733-1.53-1.487a.937.937 0 1 0-1.307 1.345l1.75 1.7a1.563 1.563 0 0 0 2.183-.006L8.47 15.45Zm3.718-.357a.937.937 0 1 0 0 1.875h5.625a.938.938 0 0 0 0-1.875h-5.625Z'
          />
        </>
      );
    case 'process':
      return (
        <>
          <path
            fill={fill}
            d='M3.75 6.25a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM16.25 18.75a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM14.687 4.688h-6.25a.938.938 0 0 1 0-1.875h6.25A4.063 4.063 0 0 1 15 10.925V9.04a2.188 2.188 0 0 0-.313-4.352ZM5 9.074a4.063 4.063 0 0 0 .313 8.114h6.25a.938.938 0 0 0 0-1.875h-6.25A2.187 2.187 0 0 1 5 10.96V9.074Z'
          />
          <path
            fill={fill}
            d='M9.525 6.447 6.447 9.525a.671.671 0 0 0 0 .95l3.078 3.078a.671.671 0 0 0 .95 0l3.078-3.078a.671.671 0 0 0 0-.95l-3.078-3.078a.671.671 0 0 0-.95 0Z'
          />
        </>
      );
    case 'calendar':
      return (
        <>
          <path
            fill={fill}
            d='M13.75 1.25a5 5 0 0 1 5 5v7.5a5 5 0 0 1-5 5h-7.5a5 5 0 0 1-5-5v-7.5a5 5 0 0 1 5-5h7.5Zm3.125 6.25H3.125v6.25c0 1.726 1.4 3.125 3.125 3.125h7.5c1.726 0 3.125-1.399 3.125-3.125V7.5Z'
          />
        </>
      );
    case 'users':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='m15.703 11.97.235.152 1.191.822a3.75 3.75 0 0 1 1.613 2.842l.008.245v.375a2.344 2.344 0 0 1-2.16 2.337l-.184.007H9.844a2.344 2.344 0 0 1-2.337-2.16l-.007-.184v-.375a3.75 3.75 0 0 1 1.424-2.941l.197-.146 1.191-.822a4.954 4.954 0 0 1 5.391-.152Zm-6.25-2.5.235.152 1.153.794a6.247 6.247 0 0 0-1.153.598l-1.75 1.153a3.75 3.75 0 0 0-1.688 3.131v.716c0 .08.003.158.01.236H3.594a2.344 2.344 0 0 1-2.337-2.16l-.007-.184v-.375a3.75 3.75 0 0 1 1.424-2.941l.197-.146 1.192-.822a4.954 4.954 0 0 1 5.39-.152Zm3.672-5.72a3.125 3.125 0 1 1 0 6.25 3.125 3.125 0 0 1 0-6.25Zm-6.25-2.5a3.125 3.125 0 1 1 0 6.25 3.125 3.125 0 0 1 0-6.25Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'inbox':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M2.606 5.824c.413-1.653.62-2.479 1.085-3.091a3.75 3.75 0 0 1 1.511-1.18c.707-.303 1.56-.303 3.263-.303h3.071c1.703 0 2.555 0 3.261.302a3.75 3.75 0 0 1 1.513 1.18c.463.613.67 1.438 1.084 3.092l1.175 4.705c.069.272.104.409.127.547.02.118.034.238.044.355.01.14.01.282.01.563v.719c0 2.136 0 3.203-.422 4.016a3.75 3.75 0 0 1-1.6 1.6c-.812.421-1.878.421-4.016.421H7.288c-2.135 0-3.203 0-4.016-.422a3.75 3.75 0 0 1-1.6-1.6c-.421-.812-.421-1.878-.421-4.016v-.718c0-.281 0-.423.01-.563.009-.119.024-.237.044-.355.034-.179.075-.356.122-.532l1.18-4.72Zm.644 5.16 1.178-4.707c.212-.852.35-1.393.483-1.802.128-.387.217-.531.275-.609.197-.258.457-.462.755-.59.09-.037.252-.087.658-.118.428-.032.987-.033 1.866-.033h3.072c.88 0 1.438 0 1.867.033.406.03.567.08.657.118.299.128.559.332.755.59.059.078.148.223.275.609.135.409.272.95.484 1.803l1.178 4.706c.075.299.087.356.096.41.01.059.017.118.022.177.004.055.005.115.005.423v.506H15.15a3.2 3.2 0 0 0-2.861 1.769 1.325 1.325 0 0 1-1.184.731H8.898a1.325 1.325 0 0 1-1.184-.731A3.199 3.199 0 0 0 4.852 12.5H3.125v-.506c0-.308.001-.368.005-.423a2.15 2.15 0 0 1 .022-.177c.01-.054.024-.113.098-.41Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'page':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M8.438 1.25v7.188c0 .974.743 1.775 1.694 1.866l.18.009H17.5v5.937a2.5 2.5 0 0 1-2.5 2.5H5a2.5 2.5 0 0 1-2.5-2.5V3.75A2.5 2.5 0 0 1 5 1.25h3.438Zm1.562 0 7.5 7.538h-6.25c-.69 0-1.25-.56-1.25-1.25V1.25Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'image':
      return (
        <>
          <path fill={fill} d='M12.5 8.125a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z' />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.59 4.206c-.34.669-.34 1.544-.34 3.294v5c0 1.75 0 2.625.34 3.293.3.588.778 1.067 1.366 1.366.669.34 1.544.34 3.294.34h7.5c1.75 0 2.625 0 3.294-.34a3.125 3.125 0 0 0 1.365-1.365c.341-.669.341-1.544.341-3.294v-5c0-1.75 0-2.625-.34-3.294a3.125 3.125 0 0 0-1.366-1.366c-.669-.34-1.544-.34-3.294-.34h-7.5c-1.75 0-2.625 0-3.294.34-.588.3-1.066.778-1.365 1.366Zm12.16.169h-7.5c-.906 0-1.473.001-1.9.036-.405.033-.517.087-.542.1a1.25 1.25 0 0 0-.547.546c-.013.026-.067.138-.1.543-.035.427-.036.994-.036 1.9v4.465l2.871-2.461a1.25 1.25 0 0 1 1.698.065l3.556 3.556 2.683-2.683a.625.625 0 0 1 .884 0l2.058 2.058v-5c0-.906-.002-1.473-.036-1.9-.034-.405-.087-.517-.1-.543a1.25 1.25 0 0 0-.547-.546c-.025-.013-.137-.067-.542-.1-.427-.035-.994-.036-1.9-.036Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'ai-document':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M6.875 1.25A3.125 3.125 0 0 0 3.75 4.375v.938a.938.938 0 0 0 1.875 0v-.938c0-.69.56-1.25 1.25-1.25H10v3.438A3.437 3.437 0 0 0 13.438 10h3.437v5.625c0 .69-.56 1.25-1.25 1.25h-2.188a.938.938 0 0 0 0 1.875h2.188c1.726 0 3.125-1.4 3.125-3.125v-6.83c0-.83-.33-1.624-.915-2.21l-4.42-4.42a3.125 3.125 0 0 0-2.21-.915h-4.33Zm9.634 6.66c.065.066.123.138.172.215h-3.244c-.862 0-1.562-.7-1.562-1.563V3.32c.077.05.149.107.214.172l4.42 4.42Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='m4.714 11.43.34-1.7a1.22 1.22 0 0 1 2.392 0l.34 1.7c.047.236.07.354.13.449a.625.625 0 0 0 .205.206c.095.058.213.082.45.13l1.698.339a1.22 1.22 0 0 1 0 2.392l-1.699.34c-.236.047-.354.07-.449.129a.625.625 0 0 0-.206.206c-.058.095-.082.213-.13.45l-.339 1.698a1.22 1.22 0 0 1-2.392 0l-.34-1.699c-.047-.236-.07-.354-.13-.449a.625.625 0 0 0-.205-.206c-.095-.058-.213-.082-.45-.13l-1.698-.339a1.22 1.22 0 0 1 0-2.392l1.699-.34c.236-.047.354-.07.449-.129a.625.625 0 0 0 .206-.206c.058-.095.082-.213.13-.45Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'attachment':
      return (
        <>
          <path
            fill={fill}
            d='m15.803 9.613-4.642 4.642c-1.81 1.81-4.482 2.008-5.953.537-1.474-1.474-1.278-4.14.532-5.949l4.262-4.262c1.167-1.167 2.87-1.292 3.79-.373.918.919.79 2.626-.372 3.789l-4.266 4.265c-.527.527-1.252.58-1.625.208-.371-.371-.318-1.099.22-1.635l3.864-3.865a.884.884 0 1 0-1.25-1.25L6.498 9.585c-1.19 1.19-1.325 3.029-.219 4.135 1.107 1.107 2.945.972 4.125-.208l4.266-4.265c1.814-1.815 2.025-4.635.371-6.289s-4.47-1.447-6.289.373L4.49 7.593c-2.463 2.463-2.741 6.24-.532 8.449 2.206 2.206 5.991 1.925 8.453-.537l4.642-4.642a.884.884 0 0 0-1.25-1.25Z'
          />
        </>
      );
    case 'sub-group':
      return (
        <>
          <path
            fill={fill}
            d='M6.25 1.25C5.56 1.25 5 1.81 5 2.5v1.25C5 4.44 5.56 5 6.25 5h7.5C14.44 5 15 4.44 15 3.75V2.5c0-.69-.56-1.25-1.25-1.25h-7.5ZM2.5 15c-.69 0-1.25.56-1.25 1.25v1.25c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25v-1.25c0-.69-.56-1.25-1.25-1.25h-5ZM4.063 13.75h1.875v-1.875c0-.518.42-.938.937-.938h1.25c.72 0 1.377-.27 1.875-.716a2.802 2.802 0 0 0 1.875.716h1.25c.518 0 .938.42.938.938v1.875h1.874v-1.875a2.813 2.813 0 0 0-2.812-2.813h-1.25a.937.937 0 0 1-.938-.937V6.25H9.063v1.875c0 .518-.42.938-.938.938h-1.25a2.813 2.813 0 0 0-2.813 2.812v1.875ZM17.5 15h-5c-.69 0-1.25.56-1.25 1.25v1.25c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25v-1.25c0-.69-.56-1.25-1.25-1.25Z'
          />
        </>
      );
    case 'union':
      return (
        <>
          <path
            fill={fill}
            d='M12.254 4.834a2.494 2.494 0 0 0 .088-1.961 2.501 2.501 0 0 0-4.684 0l-.006.017a2.495 2.495 0 0 0 .099 1.953 2.5 2.5 0 0 0 4.498 0l.005-.01ZM12.807 5.125a5.653 5.653 0 0 1 2.068 2.068 3.112 3.112 0 0 1 1.97-.261 7.528 7.528 0 0 0-3.777-3.778 3.134 3.134 0 0 1-.26 1.97ZM16.25 12.5a2.5 2.5 0 1 0-.002-5 2.5 2.5 0 0 0 .002 5ZM14.875 12.807a3.111 3.111 0 0 0 1.97.261 7.527 7.527 0 0 1-3.777 3.778 3.132 3.132 0 0 0-.26-1.97 5.653 5.653 0 0 0 2.067-2.069ZM7.75 15.157a2.5 2.5 0 1 1 4.498 2.186 2.5 2.5 0 0 1-4.497-2.186ZM7.193 14.876a5.653 5.653 0 0 1-2.068-2.069 3.112 3.112 0 0 1-1.97.261 7.528 7.528 0 0 0 3.777 3.778 3.137 3.137 0 0 1 .26-1.97ZM1.25 10a2.501 2.501 0 1 1 5.002 0 2.501 2.501 0 0 1-5.002 0ZM5.124 7.193a3.112 3.112 0 0 0-1.97-.261 7.528 7.528 0 0 1 3.778-3.778 3.14 3.14 0 0 0 .26 1.97 5.653 5.653 0 0 0-2.068 2.069Z'
          />
        </>
      );
    case 'music-key':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M18.75 3.975a2.499 2.499 0 0 0-2.911-2.465l-8.75 1.458A2.5 2.5 0 0 0 5 5.434v9.316a.25.25 0 0 1-.25.25H3.125c-1.25 0-1.875.708-1.875 1.689 0 1.137.922 2.061 2.061 2.061h1.064A3.126 3.126 0 0 0 7.5 15.625V9.388a.25.25 0 0 1 .209-.248l8.25-1.375a.25.25 0 0 1 .291.248V13.5a.25.25 0 0 1-.25.25h-1.625c-1.25 0-1.875.708-1.875 1.689 0 1.137.922 2.061 2.061 2.061h1.064a3.125 3.125 0 0 0 3.125-3.125v-10.4Zm-2.709 2.51a.25.25 0 0 0 .209-.247V4.27a.25.25 0 0 0-.291-.247l-8.25 1.375a.25.25 0 0 0-.209.247v1.967a.25.25 0 0 0 .291.247l8.25-1.375Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'dollar-bill':
      return (
        <>
          <path fill={fill} d='M12.5 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z' />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.25 5.313c0-.863.7-1.563 1.563-1.563h14.374c.863 0 1.563.7 1.563 1.563v9.375c0 .862-.7 1.562-1.563 1.562H2.813c-.862 0-1.562-.7-1.562-1.563V5.313Zm1.875 5.975V8.712A2.292 2.292 0 0 0 5 6.458v-.833h10v.833c0 1.124.808 2.058 1.875 2.254v2.576A2.292 2.292 0 0 0 15 13.542v.833H5v-.833a2.292 2.292 0 0 0-1.875-2.254Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'notepad':
      return (
        <>
          <path
            fill={fill}
            d='M6.401 1.25H13.6c.494 0 .92 0 1.271.029.371.03.74.097 1.094.278.53.27.96.7 1.23 1.229.18.354.247.723.277 1.094.029.35.029.777.029 1.271v1.1a2.534 2.534 0 0 0-1.839.743l-.036.037V5.188c0-.541 0-.89-.022-1.156-.021-.254-.056-.349-.08-.395a.938.938 0 0 0-.41-.41c-.046-.023-.14-.059-.395-.08a15.934 15.934 0 0 0-1.155-.022H6.436c-.54 0-.889 0-1.155.022-.254.021-.349.057-.395.08a.937.937 0 0 0-.41.41c-.023.046-.059.14-.08.395-.021.266-.022.615-.022 1.155v9.625c0 .541 0 .89.022 1.156.021.254.057.349.08.395.09.177.233.32.41.41.046.024.14.059.395.08.266.021.615.022 1.155.022h.138a5.785 5.785 0 0 0-.322 1.58c-.006.1-.002.199.011.295-.436 0-.816-.003-1.134-.029-.371-.03-.74-.097-1.094-.277-.53-.27-.96-.7-1.23-1.23-.18-.354-.247-.723-.277-1.094-.029-.35-.029-.777-.029-1.271V5.15c0-.494 0-.92.029-1.271.03-.371.097-.74.278-1.094.27-.53.7-.96 1.229-1.23.354-.18.723-.247 1.094-.277.35-.029.777-.029 1.271-.029ZM11.042 18.75h2.557c.494 0 .92 0 1.271-.029.371-.03.74-.097 1.094-.277.53-.27.96-.7 1.23-1.23.18-.354.247-.723.277-1.093.029-.352.029-.778.029-1.272v-2.505l-1.875 1.876v.593c0 .54 0 .89-.022 1.155-.021.255-.056.349-.08.395a.938.938 0 0 1-.41.41c-.046.024-.14.059-.395.08-.266.021-.615.022-1.155.022h-.594l-1.438 1.439c-.155.155-.319.3-.489.436ZM15.625 12.452l1.875-1.875V7.5a1.288 1.288 0 0 0-.955.377l-.92.92v3.654Z'
          />
          <path
            fill={fill}
            d='m13.722 8.934-1.691 1.691H6.562a.312.312 0 0 1-.312-.313v-1.25c0-.172.14-.312.313-.312h6.875c.126 0 .235.075.284.184ZM10.156 12.5 8.28 14.375H6.562a.312.312 0 0 1-.312-.313v-1.25c0-.172.14-.312.313-.312h3.593ZM10.049 14.375l1.875-1.875h1.514c.172 0 .312.14.312.313v1.25c0 .172-.14.312-.312.312h-3.39ZM7.926 16.875h3.276l-.555.555a4.534 4.534 0 0 1-2.928 1.32.206.206 0 0 1-.219-.219 4.535 4.535 0 0 1 .426-1.656ZM6.25 5.313c0-.173.14-.313.313-.313h6.875c.172 0 .312.14.312.313v1.25c0 .172-.14.312-.313.312H6.564a.312.312 0 0 1-.313-.313v-1.25Z'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M18.372 7.878a1.291 1.291 0 0 1 0 1.827l-7.725 7.725a4.536 4.536 0 0 1-2.928 1.32.206.206 0 0 1-.219-.219 4.535 4.535 0 0 1 1.32-2.928l7.725-7.725a1.292 1.292 0 0 1 1.827 0Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'write':
      return (
        <>
          <path
            fill={fill}
            d='M1.25 16.563c0-.518.42-.938.938-.938h15.624a.938.938 0 0 1 0 1.875H2.188a.937.937 0 0 1-.937-.938ZM17.122 4.705a1.291 1.291 0 1 0-1.827-1.827l-1.17 1.17 1.826 1.827 1.17-1.17ZM14.625 7.201 12.8 5.375 7.57 10.603a4.536 4.536 0 0 0-1.32 2.928.206.206 0 0 0 .219.218 4.536 4.536 0 0 0 2.928-1.32l5.228-5.228Z'
          />
        </>
      );
    case 'briefcase':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='m17.501 12.944-.001 3.931c0 1.035-.84 1.875-1.875 1.875H4.375A1.875 1.875 0 0 1 2.5 16.875v-3.931c.297.088.607.146.927.17l.323.011H7.5c.69 0 1.25.56 1.25 1.25 0 .307.221.562.513.615l.112.01h1.25a.625.625 0 0 0 .615-.513l.01-.112c0-.69.56-1.25 1.25-1.25h3.75c.435 0 .855-.063 1.251-.181ZM11.562 1.25c1.209 0 2.188.98 2.188 2.188V5h3.75c.69 0 1.25.56 1.25 1.25v2.5a2.5 2.5 0 0 1-2.5 2.5H3.75a2.5 2.5 0 0 1-2.5-2.5v-2.5C1.25 5.56 1.81 5 2.5 5h3.75V3.437c0-1.208.98-2.187 2.188-2.187h3.124Zm0 1.875H8.438a.312.312 0 0 0-.313.313V5h3.75V3.437a.312.312 0 0 0-.313-.312Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'rocket':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M8.366 5.236c2.089-1.95 5.244-3.986 9.315-3.986.584 0 1.058.474 1.058 1.058 0 3.564-2.062 6.72-3.964 8.894-.437.5-1.18 1.253-1.93 1.985l.733 1.468a.625.625 0 0 1-.058.654L11.126 18.5c-.36.48-1.125.226-1.125-.375v-2.34a20.783 20.783 0 0 1-.506.393l-.003.002-.088.064-.005.004-.002.002c-.42.3-.998.254-1.364-.112l-4.23-4.231a1.058 1.058 0 0 1-.171-1.273l.014-.023.21-.342c.051-.079.11-.169.178-.269H1.876c-.6 0-.855-.765-.375-1.125l3.191-2.393a.625.625 0 0 1 .655-.06l1.226.614c.67-.7 1.345-1.381 1.793-1.8Zm-4.72 5.375-.013.021.001-.002.004-.006.008-.013ZM6.25 16.25l-2.5-2.5c-1.25 0-2.5 5-2.5 5s5-1.25 5-2.5Zm8.436-9.375a1.563 1.563 0 1 0 0-3.125 1.563 1.563 0 0 0 0 3.125Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'alert':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10 18.75a8.75 8.75 0 1 0 0-17.5 8.75 8.75 0 0 0 0 17.5ZM8.783 5.656A.625.625 0 0 1 9.407 5h1.186c.357 0 .642.3.624.656l-.25 5a.625.625 0 0 1-.624.594h-.686a.625.625 0 0 1-.624-.594l-.25-5ZM8.75 13.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'email':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.125 3.75c-1.036 0-1.875.84-1.875 1.875 0 .296.18.562.455.672L9.188 9.29a2.188 2.188 0 0 0 1.625 0l7.482-2.992a.725.725 0 0 0 .455-.673c0-1.036-.84-1.875-1.875-1.875H3.125Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M18.75 9.058a.625.625 0 0 0-.857-.58l-6.384 2.553a4.063 4.063 0 0 1-3.018 0L2.107 8.479a.625.625 0 0 0-.857.58v5.317c0 1.036.84 1.875 1.875 1.875h13.75c1.035 0 1.875-.84 1.875-1.875V9.058Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'book':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M4.312 3.49A2.031 2.031 0 0 1 6.3 1.875h8.342a.87.87 0 0 1 .857 1.028L13.466 13.93a.87.87 0 0 1-1 .7.874.874 0 0 1-.146.013H4.486a.87.87 0 1 0 0 1.74h8.526c.696 0 1.294-.494 1.425-1.178l1.962-10.3a.87.87 0 0 1 1.71.325l-1.962 10.3a3.192 3.192 0 0 1-3.135 2.595H4.486a2.612 2.612 0 0 1-2.605-2.796.87.87 0 0 1 .012-.284L4.312 3.49Zm2.623.706a.58.58 0 0 0-.55.397l-.194.58a.58.58 0 0 0 .55.764h4.58a.58.58 0 0 0 .55-.396l.194-.58a.58.58 0 0 0-.55-.765h-4.58Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'education':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M9.672 1.342a.625.625 0 0 1 .656 0l8.125 5a.625.625 0 0 1 .29.622.94.94 0 0 1 .007.111v4.487a.938.938 0 0 1-1.875 0V8.378l-6.547 4.029a.625.625 0 0 1-.656 0l-8.125-5a.625.625 0 0 1 0-1.065l8.125-5Zm-4.408 9.973a.459.459 0 0 1 .513.028l3.598 2.407c.168.124 1.082.124 1.25 0l3.598-2.407a.459.459 0 0 1 .513-.028.565.565 0 0 1 .264.489v3.046a.604.604 0 0 1-.037.21c-1.817 4.92-8.108 4.92-9.926 0A.607.607 0 0 1 5 14.85v-3.046c0-.205.101-.392.264-.489Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'book-open':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M17.932 2.66a6.625 6.625 0 0 0-7.993-.066c-2.354-1.409-5.342-1.427-7.703.026l-.408.251c-.36.221-.578.613-.578 1.034v13.732c0 .86.971 1.363 1.674.866l.159-.113a5.23 5.23 0 0 1 6.202.119 1.175 1.175 0 0 0 1.43 0 5.23 5.23 0 0 1 6.202-.119l.159.113a1.061 1.061 0 0 0 1.674-.866V3.869c0-.366-.17-.71-.46-.934l-.358-.275ZM10.938 4.19a4.75 4.75 0 0 1 5.85-.045l.087.066V16.21a7.11 7.11 0 0 0-5.938-.01V4.192Zm-1.876.064C7.284 3.146 5 3.121 3.22 4.217l-.094.057V16.21a7.11 7.11 0 0 1 5.938-.01V4.256Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'airplane':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='m6.06 13.305-.405 2.927a.413.413 0 0 1-.182.294l-.491.313-1.22-3.972L1.25 9.718l.491-.312a.343.343 0 0 1 .322-.027l2.504 1.078 3.62-2.303-4.724-5.922a.44.44 0 0 1 .034-.58.376.376 0 0 1 .06-.047l.252-.16c.4-.255.894-.26 1.299-.012l6.957 4.255 3.737-2.377a2.763 2.763 0 0 1 1.735-.43l.38.034c.499.045.87.528.83 1.078-.009.12-.038.237-.084.346l-.163.38a3.191 3.191 0 0 1-1.206 1.44l-3.736 2.377-.134 8.765c-.008.51-.258.978-.659 1.233l-.252.16a.365.365 0 0 1-.067.034c-.195.073-.407-.042-.473-.258L9.68 11.004l-3.62 2.302Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'bus':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M17.5 14.143c0 .469-.112.914-.313 1.308v2.299c0 .35 0 .525-.068.659a.625.625 0 0 1-.273.273c-.134.068-.308.068-.659.068h-1.125c-.35 0-.524 0-.658-.068a.625.625 0 0 1-.273-.273c-.069-.134-.069-.309-.069-.659v-.657c-2.703.22-5.42.22-8.124 0v.657c0 .35 0 .525-.069.659a.625.625 0 0 1-.273.273c-.133.068-.308.068-.659.068H3.813c-.35 0-.525 0-.658-.068a.625.625 0 0 1-.273-.273c-.068-.134-.068-.309-.068-.659v-2.3a2.88 2.88 0 0 1-.313-1.307V10h-.625a.625.625 0 0 1-.625-.625v-2.5c0-.345.28-.625.625-.625H2.5v-2c0-1.05 0-1.575.204-1.976.18-.353.467-.64.82-.82.4-.204.926-.204 1.976-.204h9c1.05 0 1.575 0 1.976.204.353.18.64.467.82.82.204.4.204.926.204 1.976v2h.625c.345 0 .625.28.625.625v2.5c0 .345-.28.625-.625.625H17.5v4.143ZM4.375 3.358c0-.123.109-.218.231-.202.547.073 1.095.135 1.644.185V4.75c0 .138.112.25.25.25h1.375a.25.25 0 0 0 .25-.25V3.471c2.425.112 4.858.007 7.269-.315a.204.204 0 0 1 .231.202V8.75c0 1.036-.84 1.875-1.875 1.875h-7.5A1.875 1.875 0 0 1 4.375 8.75V3.358Zm11.25 9.454a.938.938 0 1 1-1.875 0 .938.938 0 0 1 1.875 0Zm-10.313.938a.938.938 0 1 0 0-1.875.938.938 0 0 0 0 1.875Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'train':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M6.66 2.5c-.497 0-.974.198-1.325.55l-.518.517a.625.625 0 1 1-.884-.884l.518-.518a3.125 3.125 0 0 1 2.21-.915h6.678c.83 0 1.624.33 2.21.915l.518.518a.625.625 0 0 1-.884.884l-.518-.518A1.875 1.875 0 0 0 13.34 2.5h-2.09v1.252c1.456.01 2.29.069 2.953.407a3.75 3.75 0 0 1 1.638 1.639c.409.802.409 1.852.409 3.952v7.043a.163.163 0 0 1-.132.16c-.426.081-.854.154-1.282.219l.789 1.578H13.75l-.68-1.362a32.484 32.484 0 0 1-5.54.051l-.655 1.311H5l.748-1.496a32.429 32.429 0 0 1-1.866-.302.162.162 0 0 1-.132-.16V9.75c0-2.1 0-3.15.409-3.952a3.75 3.75 0 0 1 1.639-1.64c.752-.383 1.724-.406 3.577-.408V2.5H6.661Zm4.59 11.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM6.875 5C5.839 5 5 5.84 5 6.875v4.375h1.875V5ZM15 6.875C15 5.839 14.16 5 13.125 5v6.25H15V6.875ZM11.875 5h-3.75v6.25h3.75V5Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'radar':
      return (
        <>
          <path
            fill={fill}
            d='M7.422 1.925c-.367-.67-1.19-.908-1.75-.406C3.057 3.867 2.32 7.92 4.1 11.17c1.78 3.25 5.48 4.603 8.717 3.39.692-.26.908-1.131.541-1.801L7.422 1.925Z'
          />
          <path fill={fill} d='m16.68 3.514-8.806 5.36-2.18-3.979c1.901.612 6.76 1.192 10.986-1.38Z' />
          <path fill={fill} d='m16.68 3.514-8.806 5.36 2.18 3.978c.447-2.04 2.4-6.765 6.627-9.338Z' />
          <path
            fill={fill}
            d='M16.15 5.606c-.695.423-1.584.172-1.985-.56s-.163-1.669.532-2.092c.695-.423 1.583-.172 1.984.56.401.733.163 1.67-.532 2.092ZM3.75 18.75a2.5 2.5 0 0 1 2.5-2.5h7.5a2.5 2.5 0 0 1 2.5 2.5H3.75Z'
          />
        </>
      );
    case 'watch':
      return (
        <>
          <path
            fill={fill}
            d='M7.846 1.25c-.51 0-.97.311-1.16.786L6.25 3.125h7.5l-.436-1.09a1.25 1.25 0 0 0-1.16-.785H7.846Z'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M16.25 11.083v1.167c0 1.4 0 2.1-.273 2.635-.24.47-.622.853-1.092 1.092-.535.273-1.235.273-2.635.273h-4.5c-1.4 0-2.1 0-2.635-.273a2.5 2.5 0 0 1-1.093-1.092c-.272-.535-.272-1.235-.272-2.635v-4.5c0-1.4 0-2.1.272-2.635a2.5 2.5 0 0 1 1.093-1.093C5.65 3.75 6.35 3.75 7.75 3.75h4.5c1.4 0 2.1 0 2.635.272a2.5 2.5 0 0 1 1.092 1.093c.168.328.232.718.257 1.293.382.214.641.623.641 1.092V10c0 .463-.251.867-.625 1.083Zm-8.5-5.458h4.5c.731 0 1.166.001 1.49.028.196.016.28.037.301.044.112.059.203.15.262.262.007.022.028.105.044.302.027.323.028.758.028 1.489v4.5c0 .731-.002 1.166-.028 1.49-.016.196-.037.28-.044.301a.626.626 0 0 1-.262.262 1.567 1.567 0 0 1-.302.044c-.323.027-.758.028-1.489.028h-4.5c-.731 0-1.166-.002-1.49-.028a1.565 1.565 0 0 1-.301-.044.626.626 0 0 1-.262-.262 1.57 1.57 0 0 1-.044-.302c-.027-.323-.028-.758-.028-1.489v-4.5c0-.731.001-1.166.028-1.49.016-.196.037-.28.044-.301a.625.625 0 0 1 .262-.262c.022-.007.105-.028.302-.044.323-.027.758-.028 1.489-.028Zm6.298.074-.004-.001.004.001Zm.253.253.001.004-.001-.004Zm0 8.096.001-.004-.001.004Zm-.253.253-.004.001.004-.001Zm-8.096 0 .004.001a.017.017 0 0 1-.004-.001Zm-.253-.253-.001-.004.001.004Zm0-8.096-.001.004.001-.004Zm.253-.253.004-.001-.004.001Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            d='M13.314 17.964a1.25 1.25 0 0 1-1.16.786H7.846a1.25 1.25 0 0 1-1.16-.786l-.436-1.089h7.5l-.436 1.09Z'
          />
        </>
      );
    case 'gears':
      return (
        <>
          <path
            fill={fill}
            d='M10.725 1.25a.625.625 0 0 1 .613.525l.312 1.85c.04.222.198.405.412.475.225.073.442.165.65.275.196.12.442.12.638 0l1.525-1.088a.625.625 0 0 1 .8 0L16.7 4.312a.625.625 0 0 1 .063.8l-1.088 1.525a.613.613 0 0 0 0 .638c.11.208.202.426.275.65.07.214.253.373.475.412l1.85.313a.625.625 0 0 1 .525.612v1.463a.625.625 0 0 1-.525.612l-1.85.313a.612.612 0 0 0-.475.412 4.236 4.236 0 0 1-.275.65.613.613 0 0 0 0 .638l1.087 1.525a.625.625 0 0 1-.062.8L15.675 16.7a.625.625 0 0 1-.8.062l-1.525-1.087a.613.613 0 0 0-.637 0c-.21.11-.426.201-.65.275a.612.612 0 0 0-.413.475l-.313 1.85a.625.625 0 0 1-.612.525h-1.45a.625.625 0 0 1-.613-.525l-.312-1.9a.612.612 0 0 0-.412-.475 4.23 4.23 0 0 1-.65-.275.613.613 0 0 0-.638 0l-1.525 1.087a.625.625 0 0 1-.8-.062L3.3 15.625a.625.625 0 0 1 0-.8L4.388 13.3a.613.613 0 0 0 0-.638 4.23 4.23 0 0 1-.276-.65.612.612 0 0 0-.474-.412l-1.863-.263a.625.625 0 0 1-.525-.612v-1.45a.625.625 0 0 1 .525-.613l1.85-.312a.613.613 0 0 0 .475-.413c.073-.224.165-.441.275-.65a.613.613 0 0 0 0-.637L3.237 5.125a.625.625 0 0 1 0-.8L4.263 3.3a.625.625 0 0 1 .8 0l1.525 1.087c.195.12.441.12.637 0 .209-.11.426-.201.65-.275a.612.612 0 0 0 .412-.475l.375-1.862a.625.625 0 0 1 .613-.525h1.45ZM10 7.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z'
          />
        </>
      );
    case 'phone':
      return (
        <>
          <path
            fill={fill}
            d='M8.513 1.422c.62.909 1.07 2.102 1.295 3.408.113.512-.281.91-.619 1.193L7.95 6.82c-.9.625 3.266 7.385 4.223 6.874l1.295-.795c.338-.228.9-.398 1.294-.057 1.07.795 1.915 1.704 2.478 2.67.262.416-.6 1.42-2.59 3.01C10.259 20.795.744 5.399 4.685 2.445c2.29-1.098 3.566-1.439 3.828-1.022Z'
          />
        </>
      );
    case 'basket':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M6.25 7.5V4.687A3.438 3.438 0 0 1 9.688 1.25h.624a3.437 3.437 0 0 1 3.438 3.438V7.5h1.94c.32 0 .587.24.622.556l1.034 9.306a1.25 1.25 0 0 1-1.242 1.388H3.896a1.25 1.25 0 0 1-1.243-1.388l1.034-9.306A.625.625 0 0 1 4.31 7.5H6.25Zm1.875-2.813c0-.862.7-1.562 1.563-1.562h.624c.864 0 1.563.7 1.563 1.563V7.5h-3.75V4.687ZM6.25 9.063V10a.937.937 0 1 0 1.875 0v-.938a1.562 1.562 0 1 1-1.875 0Zm5.625 0V10a.937.937 0 1 0 1.875 0v-.938a1.562 1.562 0 1 1-1.875 0Z'
            clipRule='evenodd'
          />
        </>
      );
    case 't-shirt':
      return (
        <>
          <path
            fill={fill}
            d='M1.377 4.872 3.17 3.08A6.25 6.25 0 0 1 7.12 1.267c.209-.015.377.156.409.362a2.5 2.5 0 0 0 4.942 0c.032-.206.2-.377.409-.362a6.25 6.25 0 0 1 3.95 1.813l1.793 1.792a.25.25 0 0 1 .046.289L17.03 8.44a.25.25 0 0 1-.4.065l-1.417-1.417a.125.125 0 0 0-.213.089V17.86c0 .155-.105.29-.255.328a19.564 19.564 0 0 1-9.49 0A.337.337 0 0 1 5 17.86V7.177a.125.125 0 0 0-.213-.089L3.37 8.505a.25.25 0 0 1-.4-.065L1.33 5.16a.25.25 0 0 1 .047-.288Z'
          />
        </>
      );
    case 'cross':
      return (
        <>
          <path
            fill={fill}
            d='M12.5 4.475c0-.677 0-1.015-.127-1.275a1.25 1.25 0 0 0-.573-.573C11.54 2.5 11.2 2.5 10.525 2.5h-1.05c-.676 0-1.015 0-1.275.127a1.25 1.25 0 0 0-.573.573c-.127.26-.127.598-.127 1.275v2.037c0 .339 0 .508-.064.638a.625.625 0 0 1-.286.286c-.13.064-.3.064-.638.064H4.476c-.676 0-1.015 0-1.275.127a1.25 1.25 0 0 0-.573.573c-.127.26-.127.598-.127 1.275v1.05c0 .676 0 1.014.127 1.275.123.249.324.45.573.572.26.128.599.128 1.275.128h2.038c.338 0 .507 0 .637.063a.625.625 0 0 1 .286.287c.064.13.064.299.064.637v2.038c0 .676 0 1.014.127 1.275.123.249.324.45.573.572.26.128.599.128 1.275.128h1.05c.676 0 1.015 0 1.275-.128.25-.122.45-.323.572-.572.128-.26.128-.599.128-1.275v-2.038c0-.338 0-.507.064-.637a.625.625 0 0 1 .286-.287c.13-.063.3-.063.638-.063h2.037c.676 0 1.015 0 1.275-.128.249-.122.45-.323.572-.572.128-.26.128-.599.128-1.275v-1.05c0-.677 0-1.015-.128-1.275a1.25 1.25 0 0 0-.572-.573C16.54 7.5 16.2 7.5 15.525 7.5h-2.037c-.339 0-.508 0-.638-.064a.625.625 0 0 1-.286-.286c-.064-.13-.064-.3-.064-.638V4.475Z'
          />
        </>
      );
    case 'pin':
      return (
        <>
          <path
            fill={fill}
            d='M10 1.25a6.25 6.25 0 0 1 6.25 6.25c0 1.228-.64 2.905-1.777 5.057a46.164 46.164 0 0 1-.892 1.606 66.91 66.91 0 0 1-2.329 3.718l-.224.33a1.25 1.25 0 0 1-2.056 0l-.405-.6-.397-.604a66.943 66.943 0 0 1-1.751-2.844 46.362 46.362 0 0 1-.892-1.606C4.391 10.405 3.75 8.727 3.75 7.5A6.25 6.25 0 0 1 10 1.25ZM10 5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z'
          />
        </>
      );
    case 'modem':
      return (
        <>
          <path
            fill={fill}
            d='M13.75 1.655c0-.145 0-.218.029-.272a.25.25 0 0 1 .104-.104c.055-.029.127-.029.272-.029h.44c.145 0 .217 0 .272.029a.25.25 0 0 1 .104.104c.029.054.029.127.029.272V8.75h-1.25V1.655Z'
          />
          <path
            fill={fill}
            d='M13.75 1.655c0-.145 0-.218.029-.272a.25.25 0 0 1 .104-.104c.055-.029.127-.029.272-.029h.44c.145 0 .217 0 .272.029a.25.25 0 0 1 .104.104c.029.054.029.127.029.272V8.75h-1.25V1.655Z'
          />
          <path
            fill={fill}
            d='M13.75 1.655c0-.145 0-.218.029-.272a.25.25 0 0 1 .104-.104c.055-.029.127-.029.272-.029h.44c.145 0 .217 0 .272.029a.25.25 0 0 1 .104.104c.029.054.029.127.029.272V8.75h-1.25V1.655Z'
          />
          <path
            fill={fill}
            d='M13.75 1.655c0-.145 0-.218.029-.272a.25.25 0 0 1 .104-.104c.055-.029.127-.029.272-.029h.44c.145 0 .217 0 .272.029a.25.25 0 0 1 .104.104c.029.054.029.127.029.272V8.75h-1.25V1.655ZM10 5.405V8.75H8.75V5.405c0-.145 0-.218.029-.272a.25.25 0 0 1 .104-.104C8.938 5 9.01 5 9.155 5h.44c.145 0 .217 0 .272.029a.25.25 0 0 1 .104.104c.029.054.029.127.029.272Z'
          />
          <path
            fill={fill}
            d='M10 5.405V8.75H8.75V5.405c0-.145 0-.218.029-.272a.25.25 0 0 1 .104-.104C8.938 5 9.01 5 9.155 5h.44c.145 0 .217 0 .272.029a.25.25 0 0 1 .104.104c.029.054.029.127.029.272Z'
          />
          <path
            fill={fill}
            d='M10 5.405V8.75H8.75V5.405c0-.145 0-.218.029-.272a.25.25 0 0 1 .104-.104C8.938 5 9.01 5 9.155 5h.44c.145 0 .217 0 .272.029a.25.25 0 0 1 .104.104c.029.054.029.127.029.272Z'
          />
          <path
            fill={fill}
            d='M10 5.405V8.75H8.75V5.405c0-.145 0-.218.029-.272a.25.25 0 0 1 .104-.104C8.938 5 9.01 5 9.155 5h.44c.145 0 .217 0 .272.029a.25.25 0 0 1 .104.104c.029.054.029.127.029.272Z'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.468 10.998c-.218.412-.218.955-.218 2.04v1.425c0 1.085 0 1.628.218 2.04.175.332.447.604.78.78.337.178.762.21 1.502.216v.239c0 .362 0 .542.072.68.06.11.15.2.26.26.138.072.32.072.68.072h.476c.362 0 .542 0 .68-.073a.625.625 0 0 0 .26-.26c.072-.137.072-.318.072-.68V17.5h7.5v.238c0 .362 0 .542.072.68.06.11.15.2.26.26.138.072.32.072.68.072h.476c.362 0 .542 0 .68-.073a.624.624 0 0 0 .26-.26c.072-.137.072-.318.072-.68V17.5c.74-.006 1.165-.038 1.503-.216.332-.176.604-.448.78-.78.217-.413.217-.956.217-2.04v-1.425c0-1.085 0-1.63-.218-2.04a1.875 1.875 0 0 0-.78-.78C17.34 10 16.799 10 15.713 10H4.287c-1.084 0-1.628 0-2.04.217a1.875 1.875 0 0 0-.78.78Zm7.354 1.835c-.072.137-.072.318-.072.68v.475c0 .362 0 .542.072.68.06.11.15.2.26.26.138.072.32.072.68.072h4.226c.362 0 .542 0 .68-.072a.624.624 0 0 0 .26-.26c.072-.138.072-.32.072-.68v-.476c0-.362 0-.542-.072-.68a.624.624 0 0 0-.26-.26c-.138-.072-.32-.072-.68-.072H9.762c-.362 0-.542 0-.68.072a.625.625 0 0 0-.26.26Zm-1.322.68c0-.363 0-.543-.072-.68a.625.625 0 0 0-.26-.26c-.138-.073-.32-.073-.68-.073h-.476c-.362 0-.542 0-.68.072a.625.625 0 0 0-.26.26c-.072.138-.072.32-.072.68v.476c0 .362 0 .542.072.68.06.11.15.2.26.26.138.072.32.072.68.072h.476c.362 0 .542 0 .68-.072a.625.625 0 0 0 .26-.26c.072-.138.072-.32.072-.68v-.476Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.468 10.998c-.218.412-.218.955-.218 2.04v1.425c0 1.085 0 1.628.218 2.04.175.332.447.604.78.78.337.178.762.21 1.502.216v.239c0 .362 0 .542.072.68.06.11.15.2.26.26.138.072.32.072.68.072h.476c.362 0 .542 0 .68-.073a.625.625 0 0 0 .26-.26c.072-.137.072-.318.072-.68V17.5h7.5v.238c0 .362 0 .542.072.68.06.11.15.2.26.26.138.072.32.072.68.072h.476c.362 0 .542 0 .68-.073a.624.624 0 0 0 .26-.26c.072-.137.072-.318.072-.68V17.5c.74-.006 1.165-.038 1.503-.216.332-.176.604-.448.78-.78.217-.413.217-.956.217-2.04v-1.425c0-1.085 0-1.63-.218-2.04a1.875 1.875 0 0 0-.78-.78C17.34 10 16.799 10 15.713 10H4.287c-1.084 0-1.628 0-2.04.217a1.875 1.875 0 0 0-.78.78Zm7.354 1.835c-.072.137-.072.318-.072.68v.475c0 .362 0 .542.072.68.06.11.15.2.26.26.138.072.32.072.68.072h4.226c.362 0 .542 0 .68-.072a.624.624 0 0 0 .26-.26c.072-.138.072-.32.072-.68v-.476c0-.362 0-.542-.072-.68a.624.624 0 0 0-.26-.26c-.138-.072-.32-.072-.68-.072H9.762c-.362 0-.542 0-.68.072a.625.625 0 0 0-.26.26Zm-1.322.68c0-.363 0-.543-.072-.68a.625.625 0 0 0-.26-.26c-.138-.073-.32-.073-.68-.073h-.476c-.362 0-.542 0-.68.072a.625.625 0 0 0-.26.26c-.072.138-.072.32-.072.68v.476c0 .362 0 .542.072.68.06.11.15.2.26.26.138.072.32.072.68.072h.476c.362 0 .542 0 .68-.072a.625.625 0 0 0 .26-.26c.072-.138.072-.32.072-.68v-.476Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.468 10.998c-.218.412-.218.955-.218 2.04v1.425c0 1.085 0 1.628.218 2.04.175.332.447.604.78.78.337.178.762.21 1.502.216v.239c0 .362 0 .542.072.68.06.11.15.2.26.26.138.072.32.072.68.072h.476c.362 0 .542 0 .68-.073a.625.625 0 0 0 .26-.26c.072-.137.072-.318.072-.68V17.5h7.5v.238c0 .362 0 .542.072.68.06.11.15.2.26.26.138.072.32.072.68.072h.476c.362 0 .542 0 .68-.073a.624.624 0 0 0 .26-.26c.072-.137.072-.318.072-.68V17.5c.74-.006 1.165-.038 1.503-.216.332-.176.604-.448.78-.78.217-.413.217-.956.217-2.04v-1.425c0-1.085 0-1.63-.218-2.04a1.875 1.875 0 0 0-.78-.78C17.34 10 16.799 10 15.713 10H4.287c-1.084 0-1.628 0-2.04.217a1.875 1.875 0 0 0-.78.78Zm7.354 1.835c-.072.137-.072.318-.072.68v.475c0 .362 0 .542.072.68.06.11.15.2.26.26.138.072.32.072.68.072h4.226c.362 0 .542 0 .68-.072a.624.624 0 0 0 .26-.26c.072-.138.072-.32.072-.68v-.476c0-.362 0-.542-.072-.68a.624.624 0 0 0-.26-.26c-.138-.072-.32-.072-.68-.072H9.762c-.362 0-.542 0-.68.072a.625.625 0 0 0-.26.26Zm-1.322.68c0-.363 0-.543-.072-.68a.625.625 0 0 0-.26-.26c-.138-.073-.32-.073-.68-.073h-.476c-.362 0-.542 0-.68.072a.625.625 0 0 0-.26.26c-.072.138-.072.32-.072.68v.476c0 .362 0 .542.072.68.06.11.15.2.26.26.138.072.32.072.68.072h.476c.362 0 .542 0 .68-.072a.625.625 0 0 0 .26-.26c.072-.138.072-.32.072-.68v-.476Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M1.468 10.998c-.218.412-.218.955-.218 2.04v1.425c0 1.085 0 1.628.218 2.04.175.332.447.604.78.78.337.178.762.21 1.502.216v.239c0 .362 0 .542.072.68.06.11.15.2.26.26.138.072.32.072.68.072h.476c.362 0 .542 0 .68-.073a.625.625 0 0 0 .26-.26c.072-.137.072-.318.072-.68V17.5h7.5v.238c0 .362 0 .542.072.68.06.11.15.2.26.26.138.072.32.072.68.072h.476c.362 0 .542 0 .68-.073a.624.624 0 0 0 .26-.26c.072-.137.072-.318.072-.68V17.5c.74-.006 1.165-.038 1.503-.216.332-.176.604-.448.78-.78.217-.413.217-.956.217-2.04v-1.425c0-1.085 0-1.63-.218-2.04a1.875 1.875 0 0 0-.78-.78C17.34 10 16.799 10 15.713 10H4.287c-1.084 0-1.628 0-2.04.217a1.875 1.875 0 0 0-.78.78Zm7.354 1.835c-.072.137-.072.318-.072.68v.475c0 .362 0 .542.072.68.06.11.15.2.26.26.138.072.32.072.68.072h4.226c.362 0 .542 0 .68-.072a.624.624 0 0 0 .26-.26c.072-.138.072-.32.072-.68v-.476c0-.362 0-.542-.072-.68a.624.624 0 0 0-.26-.26c-.138-.072-.32-.072-.68-.072H9.762c-.362 0-.542 0-.68.072a.625.625 0 0 0-.26.26Zm-1.322.68c0-.363 0-.543-.072-.68a.625.625 0 0 0-.26-.26c-.138-.073-.32-.073-.68-.073h-.476c-.362 0-.542 0-.68.072a.625.625 0 0 0-.26.26c-.072.138-.072.32-.072.68v.476c0 .362 0 .542.072.68.06.11.15.2.26.26.138.072.32.072.68.072h.476c.362 0 .542 0 .68-.072a.625.625 0 0 0 .26-.26c.072-.138.072-.32.072-.68v-.476Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'burger':
      return (
        <>
          <path
            fill={fill}
            d='M2.5 8.438A5.938 5.938 0 0 1 8.438 2.5h3.124A5.937 5.937 0 0 1 17.5 8.438a.312.312 0 0 1-.313.312H2.813a.312.312 0 0 1-.312-.313Zm.625 2.187a.625.625 0 0 0-.625.625v1.25a.625.625 0 0 0 .625.625h5.732c.332 0 .65.132.884.366L11.7 15.45a.25.25 0 0 0 .352 0l1.958-1.958a1.25 1.25 0 0 1 .883-.366h1.983a.624.624 0 0 0 .625-.625v-1.25a.624.624 0 0 0-.625-.625H3.125Z'
          />
          <path
            fill={fill}
            d='M9.592 15.11a.375.375 0 0 0-.264-.11H3.215a.713.713 0 0 0-.715.714c0 .987.8 1.786 1.786 1.786h11.428c.987 0 1.786-.8 1.786-1.786a.714.714 0 0 0-.714-.714h-2.362a.375.375 0 0 0-.266.11l-1.223 1.223a1.5 1.5 0 0 1-2.121 0L9.592 15.11Z'
          />
        </>
      );
    case 'chemist':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M7.5 3.125v5.473c0 .056 0 .084-.006.111a.25.25 0 0 1-.026.068.532.532 0 0 1-.069.087l-4.098 4.61A3.17 3.17 0 0 0 5.67 18.75h8.66a3.17 3.17 0 0 0 2.37-5.276L12.6 8.864a.535.535 0 0 1-.07-.087.252.252 0 0 1-.025-.068c-.006-.027-.006-.055-.006-.111V3.125h.625c.345 0 .625-.28.625-.625v-.625a.625.625 0 0 0-.625-.625h-6.25a.625.625 0 0 0-.625.625V2.5c0 .345.28.625.625.625H7.5Zm3.125 0h-1.25V8.75L6 13.25c.912-.456 2.365-.75 4-.75 1.636 0 3.088.294 4 .75l-3.375-4.5V3.125Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'electric-plug':
      return (
        <>
          <path
            fill={fill}
            d='M7.188 1.25a.938.938 0 0 0-.938.938V6.25H4.375a.625.625 0 0 0-.625.625V7.5c0 .345.28.625.625.625H5v3.125a2.5 2.5 0 0 0 2.5 2.5h5a2.5 2.5 0 0 0 2.5-2.5V8.125h.625c.345 0 .625-.28.625-.625v-.625a.625.625 0 0 0-.625-.625H13.75V2.187a.938.938 0 0 0-1.875 0V6.25h-3.75V2.187a.938.938 0 0 0-.938-.937ZM16.54 16.799a1.37 1.37 0 0 1 1.273-.861.938.938 0 0 0 0-1.876c-1.328 0-2.52.808-3.014 2.04l-.044.112a1.548 1.548 0 0 1-1.438.974h-.335a2.044 2.044 0 0 1-2.044-2.044V15H9.062v.143a3.919 3.919 0 0 0 3.92 3.92h.335c1.4 0 2.659-.853 3.178-2.152l.045-.112Z'
          />
        </>
      );
    case 'health':
      return (
        <>
          <path
            fill={fill}
            d='M1.25 6.334c0-2.808 2.239-5.084 5-5.084 1.493 0 2.834.666 3.75 1.721a4.953 4.953 0 0 1 3.75-1.721c2.761 0 5 2.276 5 5.084 0 .95-.195 1.912-.527 2.864h-3.584c-.388 0-.76.16-1.03.441l-2.144 2.233L8.743 6.36a1.429 1.429 0 0 0-2.527-.082L4.533 9.198H1.875v.27C1.484 8.43 1.25 7.374 1.25 6.335Z'
          />
          <path
            fill={fill}
            d='M2.485 10.844c1.465 2.89 5.195 6.039 7.091 7.743a.633.633 0 0 0 .85 0c1.895-1.704 5.626-4.853 7.09-7.743H14.72l-2.272 2.367a1.428 1.428 0 0 1-2.316-.364L7.445 7.41l-1.563 2.713c-.257.447-.73.722-1.241.722H2.485Z'
          />
        </>
      );
    case 'speaker':
      return (
        <>
          <path fill={fill} d='M10 14.375a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z' />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.954 2.274c-.204.4-.204.926-.204 1.976v11.5c0 1.05 0 1.575.204 1.976.18.353.467.64.82.82.4.204.926.204 1.976.204h6.5c1.05 0 1.575 0 1.976-.204.353-.18.64-.467.82-.82.204-.4.204-.926.204-1.976V4.25c0-1.05 0-1.575-.204-1.976a1.875 1.875 0 0 0-.82-.82c-.4-.204-.926-.204-1.976-.204h-6.5c-1.05 0-1.575 0-1.976.204-.353.18-.64.467-.82.82ZM10 16.875a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5ZM11.875 5a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'android':
      return (
        <>
          <path
            fill={fill}
            d='M3.582 6.931c-.602 0-1.082.48-1.082 1.083v4.508c0 .603.48 1.083 1.082 1.083.603 0 1.083-.48 1.083-1.083V8.014c0-.603-.48-1.083-1.083-1.083Zm11.14.186v6.997c0 .603-.454 1.097-1.04 1.16l-.127.007h-.775v2.387c0 .603-.479 1.082-1.082 1.082-.56 0-1.013-.413-1.075-.955l-.007-.127-.001-2.387H9.173v2.387c0 .603-.479 1.082-1.082 1.082-.56 0-1.013-.413-1.075-.955l-.007-.127V15.28h-.774a1.164 1.164 0 0 1-1.16-1.04l-.007-.127V7.117h9.654Zm1.485-.186c.56 0 1.014.414 1.075.955l.008.128v4.508c0 .603-.48 1.083-1.083 1.083-.56 0-1.013-.414-1.075-.955l-.007-.128V8.014c0-.603.48-1.083 1.082-1.083Zm-3.315-5.68a.15.15 0 0 1 .073.02c.062.033.09.097.077.16l-.018.048-.762 1.378c1.394.725 2.358 2.07 2.452 3.63l.008.248H5.068c.002-1.581.896-2.97 2.243-3.759l.217-.12-.763-1.377a.15.15 0 0 1 .06-.209.15.15 0 0 1 .173.016l.036.044.772 1.392a5.146 5.146 0 0 1 2.089-.437c.64 0 1.253.115 1.813.325l.275.112.773-1.392a.151.151 0 0 1 .136-.08ZM7.667 4.162a.405.405 0 0 0-.403.403c0 .22.183.402.403.402.22 0 .403-.182.403-.402a.405.405 0 0 0-.403-.403Zm4.456 0a.405.405 0 0 0-.403.403c0 .22.182.402.403.402.22 0 .402-.182.402-.402a.405.405 0 0 0-.402-.403Z'
          />
        </>
      );
    case 'chrome':
      return (
        <>
          <path
            fill={fill}
            d='M10 14.466c-.875 0-1.69-.242-2.414-.725-.724-.482-1.267-1.086-1.63-1.84l-3.62-6.276C1.582 6.983 1.25 8.461 1.25 10c0 2.203.724 4.104 2.142 5.733 1.418 1.63 3.199 2.595 5.31 2.927l2.535-4.406a3.67 3.67 0 0 1-1.237.212ZM7.254 6.38c.815-.634 1.72-.906 2.746-.906h7.513c-.785-1.327-1.84-2.293-3.168-3.047A8.388 8.388 0 0 0 10 1.25a8.706 8.706 0 0 0-3.832.875C4.99 2.698 3.875 3.543 3.09 4.629l2.535 4.164c.241-.965.814-1.78 1.63-2.414Z'
          />
          <path
            fill={fill}
            d='M18.087 6.711h-5.07c.876.875 1.48 2.022 1.48 3.289 0 .935-.273 1.78-.785 2.565L10.09 18.75c2.383-.03 4.435-.875 6.125-2.595 1.69-1.72 2.534-3.771 2.534-6.155 0-1.116-.18-2.293-.663-3.289Z'
          />
          <path
            fill={fill}
            d='M10 6.681c1.81 0 3.32 1.509 3.32 3.32 0 1.81-1.51 3.318-3.32 3.318-1.81 0-3.319-1.509-3.319-3.319s1.509-3.319 3.32-3.319Z'
          />
        </>
      );
    case 'box':
      return (
        <>
          <path
            fill={fill}
            d='M10.765 1.395a2.093 2.093 0 0 0-1.531 0l-6.74 2.686 2.644 1.003 7.534-2.93-1.907-.759ZM15.495 3.28 8.032 6.182l1.182.448a2.187 2.187 0 0 1 1.411 2.045v10.033c.367-.05.728-.144 1.071-.282l6.002-2.41c.642-.258 1.052-.813 1.052-1.422V5.628h-.002c.021-.587-.33-1.184-1.056-1.473l-2.197-.875Z'
          />
          <path
            fill={fill}
            d='M3.75 6.563v2.503a.5.5 0 0 0 .276.447l1.862.93a.25.25 0 0 0 .362-.223V7.512l2.298.871a.312.312 0 0 1 .202.293v9.902a4.443 4.443 0 0 1-.446-.152l-6.002-2.41c-.642-.258-1.052-.812-1.052-1.422V5.615l2.5.948Z'
          />
        </>
      );
    case 'shop':
      return (
        <>
          <path
            fill={fill}
            d='M6.161 9.369c.085-.335.357-.619.702-.619s.617.284.702.619a2.501 2.501 0 0 0 4.846 0c.085-.335.357-.619.702-.619s.617.284.702.619a2.5 2.5 0 0 0 4.906-.324.997.997 0 0 0-.115-.559l-3.272-6.545a1.25 1.25 0 0 0-1.118-.691H5.76a1.25 1.25 0 0 0-1.118.691L1.37 8.486a.997.997 0 0 0-.115.559 2.5 2.5 0 0 0 4.906.324Z'
          />
          <path
            fill={fill}
            d='M3.763 12.5a3.745 3.745 0 0 0 3.125-1.677 3.745 3.745 0 0 0 3.125 1.677 3.745 3.745 0 0 0 3.125-1.677 3.745 3.745 0 0 0 4.35 1.473v4.579c0 1.035-.84 1.875-1.876 1.875h-2.488a.625.625 0 0 1-.625-.625V16.25c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v1.875c0 .345-.28.625-.624.625H4.362a1.875 1.875 0 0 1-1.875-1.875v-4.598c.398.144.828.223 1.276.223Z'
          />
        </>
      );
    case 'bank':
      return (
        <>
          <path
            fill={fill}
            d='M9.619 1.38a.625.625 0 0 1 .762 0l8.125 6.25a.625.625 0 0 1-.381 1.12H1.875a.625.625 0 0 1-.381-1.12l8.125-6.25ZM1.25 18.173c0-.627 0-.941.11-1.186a1.25 1.25 0 0 1 .627-.627c.245-.11.558-.11 1.186-.11h.177c.14 0 .21 0 .264-.027a.25.25 0 0 0 .109-.11c.027-.053.027-.123.027-.263V10.6c0-.21 0-.315.04-.395a.375.375 0 0 1 .165-.164C4.035 10 4.14 10 4.35 10h1.3c.21 0 .315 0 .395.04.07.037.128.094.164.165.041.08.041.185.041.395v5.25c0 .14 0 .21.027.263a.25.25 0 0 0 .11.11c.053.027.123.027.263.027h1.7c.14 0 .21 0 .264-.027a.25.25 0 0 0 .109-.11c.027-.053.027-.123.027-.263V10.6c0-.21 0-.315.04-.395a.375.375 0 0 1 .165-.164C9.035 10 9.14 10 9.35 10h1.3c.21 0 .315 0 .395.04.07.037.128.094.164.165.041.08.041.185.041.395v5.25c0 .14 0 .21.027.263a.25.25 0 0 0 .11.11c.053.027.123.027.263.027h1.7c.14 0 .21 0 .264-.027a.249.249 0 0 0 .109-.11c.027-.053.027-.123.027-.263V10.6c0-.21 0-.315.04-.395a.375.375 0 0 1 .165-.164c.08-.041.185-.041.395-.041h1.3c.21 0 .315 0 .395.04.07.037.128.094.164.165.041.08.041.185.041.395v5.25c0 .14 0 .21.027.263a.25.25 0 0 0 .11.11c.053.027.123.027.263.027h.177c.628 0 .941 0 1.186.11.279.125.502.349.627.627.11.245.11.559.11 1.186 0 .188 0 .283-.033.356a.375.375 0 0 1-.188.188c-.073.033-.168.033-.356.033H1.827c-.188 0-.282 0-.356-.033a.375.375 0 0 1-.188-.188c-.033-.073-.033-.168-.033-.356Z'
          />
        </>
      );
    case 'network':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M14.687 13.677a.938.938 0 0 0 1.251 1.396A8.47 8.47 0 0 0 18.75 8.75a8.47 8.47 0 0 0-2.812-6.323.938.938 0 0 0-1.251 1.396 6.595 6.595 0 0 1 2.188 4.927 6.595 6.595 0 0 1-2.188 4.927Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M13.088 11.21a.938.938 0 0 0 1.324 1.33c.948-.946 1.525-2.304 1.525-3.79 0-1.486-.577-2.844-1.525-3.79a.938.938 0 0 0-1.324 1.33c.585.581.975 1.457.975 2.46s-.39 1.879-.975 2.46ZM5.386 2.5a.938.938 0 0 1-.073 1.323A6.595 6.595 0 0 0 3.125 8.75c0 1.965.847 3.725 2.188 4.927a.937.937 0 1 1-1.251 1.396A8.47 8.47 0 0 1 1.25 8.75a8.47 8.47 0 0 1 2.812-6.323.937.937 0 0 1 1.324.072Z'
            clipRule='evenodd'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M6.914 4.963a.938.938 0 0 1-.002 1.326c-.585.582-.974 1.458-.974 2.461s.39 1.879.974 2.46a.937.937 0 1 1-1.324 1.33c-.948-.946-1.526-2.304-1.526-3.79 0-1.486.578-2.844 1.526-3.79a.938.938 0 0 1 1.326.003ZM10.938 11.068a2.5 2.5 0 1 0-1.876 0v6.745a.938.938 0 0 0 1.876 0v-6.745Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'open-ai':
      return (
        <>
          <path
            fill={fill}
            d='M8.82 0A5.06 5.06 0 0 0 4.01 3.488 5 5 0 0 0 .679 5.906a5.037 5.037 0 0 0 .623 5.905 4.963 4.963 0 0 0 .427 4.085 5.05 5.05 0 0 0 5.432 2.425 4.986 4.986 0 0 0 3.751 1.68 5.06 5.06 0 0 0 4.809-3.488 4.974 4.974 0 0 0 3.325-2.42 5.027 5.027 0 0 0-.615-5.904V8.18a4.983 4.983 0 0 0-.428-4.09 5.051 5.051 0 0 0-5.425-2.418A5.006 5.006 0 0 0 8.82 0Zm0 1.3-.006.008c.88 0 1.726.305 2.403.866-.027.014-.081.047-.121.069L7.112 4.538a.649.649 0 0 0-.325.57v5.39L5.074 9.51V5.051a3.75 3.75 0 0 1 3.746-3.75Zm4.797 1.57a3.748 3.748 0 0 1 3.703 4.384c-.028-.02-.082-.048-.115-.068l-3.983-2.302a.666.666 0 0 0-.657 0L7.9 7.579V5.6l3.854-2.228a3.73 3.73 0 0 1 1.864-.503Zm-9.85 2.048V9.65c0 .238.123.448.325.569l4.66 2.689-1.721.996-3.846-2.223a3.75 3.75 0 0 1 .582-6.763Zm8.927 1.17 3.853 2.222a3.744 3.744 0 0 1 1.369 5.121l.006.007a3.738 3.738 0 0 1-1.95 1.638v-4.733a.647.647 0 0 0-.325-.57L10.98 7.079l1.715-.99ZM9.861 7.722l1.965 1.138v2.269l-1.965 1.137L7.9 11.128v-2.27l1.962-1.137Zm3.089 1.788 1.713.989v4.45A3.75 3.75 0 0 1 10.92 18.7v-.006a3.737 3.737 0 0 1-2.399-.868c.028-.012.088-.047.123-.067l3.982-2.296a.634.634 0 0 0 .325-.57V9.51Zm-1.117 2.912V14.4L7.98 16.62a3.756 3.756 0 0 1-5.12-1.367h.006a3.719 3.719 0 0 1-.447-2.507c.027.02.08.048.116.068l3.981 2.304a.668.668 0 0 0 .658 0l4.66-2.697Z'
          />
          <defs>
            <clipPath id='a'>
              <path fill='#fff' d='M0 0h20v20H0z' />
            </clipPath>
          </defs>
        </>
      );
    case 'joystick':
      return (
        <>
          <path
            fill={fill}
            d='M11.25 5.916A2.499 2.499 0 0 0 10 1.25a2.5 2.5 0 1 0 1.25 4.666ZM8.75 6.615v4.791c0 .37 2.5.37 2.5 0v-4.79c-.383.166-.806.26-1.25.26-.444 0-.867-.094-1.25-.26Z'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='m7.5 8.75-4.309 2.155a1.25 1.25 0 0 0-.691 1.118v2.204c0 .474.268.907.691 1.118l6.25 3.126a1.25 1.25 0 0 0 1.118 0l6.25-3.126a1.25 1.25 0 0 0 .691-1.118v-2.204a1.25 1.25 0 0 0-.691-1.118L12.5 8.75v2.656c0 .823-.673 1.176-.792 1.236-.219.112-.447.167-.607.199a5.951 5.951 0 0 1-1.101.093c-.36 0-.76-.026-1.101-.093a2.368 2.368 0 0 1-.607-.199c-.12-.06-.792-.413-.792-1.236V8.75Zm8.75 4.816a.5.5 0 0 1-.276.447l-5.612 2.806a.25.25 0 0 1-.362-.223v-.662a.5.5 0 0 1 .276-.447l5.612-2.806a.25.25 0 0 1 .362.224v.661Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'umbrella':
      return (
        <>
          <path
            fill={fill}
            d='M10 1.25c-.172 0-.343.557-.463 1.263-3.227.174-7.864 2.146-8.26 6.833-.019.228.265.347.44.199C2.388 8.974 3.332 8.5 4.616 8.5c.98 0 1.76.552 2.224.986.25.234.686.234.935 0C8.24 9.052 9.02 8.5 10 8.5c1.104 0 1.746.467 2.186.922.251.26.735.238 1.014.008.556-.458 1.445-.93 2.185-.93.83 0 1.981.446 2.773.994.2.139.522-.03.479-.27-.93-5.102-5.01-6.586-8.174-6.715-.12-.704-.291-1.259-.463-1.259ZM10.938 10.817c0-.518-.42-.817-.938-.817s-.938.299-.938.817v5.12a.938.938 0 0 1-1.874 0V15c0-.518-.42-.625-.938-.625s-.938.107-.938.625v.937a2.813 2.813 0 0 0 5.625 0v-5.12Z'
          />
        </>
      );
    case 'lock':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M13.75 8.75a2.5 2.5 0 0 1 2.5 2.5v5a2.5 2.5 0 0 1-2.5 2.5h-7.5a2.5 2.5 0 0 1-2.5-2.5v-5a2.5 2.5 0 0 1 2.5-2.5h7.5ZM10 11.25A1.875 1.875 0 1 0 10 15a1.875 1.875 0 0 0 0-3.75Zm0-10A3.75 3.75 0 0 1 13.75 5v2.5h-1.875V5a1.875 1.875 0 0 0-3.75 0v2.5H6.25V5A3.75 3.75 0 0 1 10 1.25Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'cone':
      return (
        <>
          <path
            fill={fill}
            d='M14.844 13.26a.375.375 0 0 1-.358.49H5.514a.375.375 0 0 1-.357-.49l1.015-3.173a.125.125 0 0 1 .12-.087h7.417c.054 0 .103.035.119.087l1.016 3.174ZM12.429 6.25a.125.125 0 0 0 .119-.163L11.084 1.51a.375.375 0 0 0-.358-.261H9.274a.375.375 0 0 0-.357.26L7.452 6.088a.125.125 0 0 0 .12.163h4.857ZM5 15c-.69 0-1.25.56-1.25 1.25a2.5 2.5 0 0 0-2.488 2.25c-.013.138.1.25.238.25h17c.138 0 .251-.112.238-.25a2.5 2.5 0 0 0-2.488-2.25c0-.69-.56-1.25-1.25-1.25H5Z'
          />
        </>
      );
    case 'chat':
      return (
        <>
          <path
            fill={fill}
            d='M1.318 6.12c-.068.438-.068.96-.068 2.005s0 1.568.068 2.005a5.75 5.75 0 0 0 4.096 4.647l-.41 3.27a.625.625 0 0 0 1.063.52L9.634 15h2.241c1.045 0 1.568 0 2.005-.068a5.75 5.75 0 0 0 4.802-4.802c.068-.437.068-.96.068-2.005s0-1.567-.068-2.005a5.75 5.75 0 0 0-4.802-4.802c-.437-.068-.96-.068-2.005-.068h-3.75c-1.045 0-1.568 0-2.005.068A5.75 5.75 0 0 0 1.318 6.12Z'
          />
        </>
      );
    case 'video':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.75 2.5A2.5 2.5 0 0 0 1.25 5v10a2.5 2.5 0 0 0 2.5 2.5h12.5a2.5 2.5 0 0 0 2.5-2.5V5a2.5 2.5 0 0 0-2.5-2.5H3.75Zm4.92 3.738a.75.75 0 0 0-1.17.622v6.28c0 .6.671.958 1.17.622l4.657-3.14a.75.75 0 0 0 0-1.244L8.67 6.238Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'shield':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10.56 1.595a.625.625 0 0 0-1.138.048c-.381.953-1.238 2.222-2.452 2.887a3.559 3.559 0 0 1-2.04.443c-.767-.064-1.664-.377-2.684-1.107a.624.624 0 0 0-.988.483c-.11 2.642.87 6.19 2.415 9.072.776 1.446 1.714 2.76 2.764 3.72 1.046.957 2.258 1.609 3.565 1.609 1.31 0 2.509-.654 3.54-1.612 1.035-.962 1.952-2.276 2.715-3.721 1.52-2.882 2.493-6.419 2.493-9.042a.625.625 0 0 0-.988-.509c-1.032.738-1.911 1.076-2.652 1.168a3.176 3.176 0 0 1-1.925-.352c-1.15-.609-2.014-1.866-2.624-3.087Zm2.986 7.135a.481.481 0 0 1 .191.513.478.478 0 0 1-.154.244l-1.67 1.374a.159.159 0 0 0-.05.173l.7 2.086a.477.477 0 0 1-.459.63.485.485 0 0 1-.285-.093l-1.72-1.25a.162.162 0 0 0-.19 0l-1.72 1.25a.485.485 0 0 1-.744-.24.475.475 0 0 1 .001-.297l.701-2.084a.158.158 0 0 0-.05-.174L6.43 9.49a.478.478 0 0 1 .31-.846H8.7a.162.162 0 0 0 .15-.107l.702-1.97.002-.006a.48.48 0 0 1 .452-.311.485.485 0 0 1 .452.311l.703 1.976a.16.16 0 0 0 .152.107h1.958c.099 0 .195.03.276.086Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'anchor':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10.938 6.068a2.5 2.5 0 1 0-1.875 0v1.495a.25.25 0 0 1-.25.25H7.5a.938.938 0 0 0 0 1.875h1.313a.25.25 0 0 1 .25.25V14.9c0 .16-.147.278-.3.236-.748-.21-1.462-.59-2.11-1.054-.996-.714-1.755-1.573-2.133-2.117a.937.937 0 1 0-1.54 1.07c.49.706 1.398 1.722 2.58 2.57.911.654 2.033 1.24 3.29 1.475a.257.257 0 0 1 .213.25v.483c0 .386.523.718.787.861.094.051.206.051.3 0 .265-.143.788-.475.788-.861v-.482c0-.124.09-.229.211-.251 1.258-.234 2.38-.821 3.29-1.474 1.184-.849 2.09-1.865 2.581-2.571a.938.938 0 0 0-1.54-1.07c-.378.544-1.137 1.403-2.133 2.117-.648.464-1.362.844-2.109 1.054a.239.239 0 0 1-.3-.236V9.938a.25.25 0 0 1 .25-.25H12.5a.937.937 0 1 0 0-1.874h-1.312a.25.25 0 0 1-.25-.25V6.067Zm.312-2.318C11.25 4.375 10.938 5 10 5c-.937 0-1.25-.625-1.25-1.25S9.063 2.5 10 2.5c.938 0 1.25.625 1.25 1.25Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'coffee':
      return (
        <>
          {' '}
          <path
            fill={fill}
            d='M14.375 1.25a.625.625 0 0 1 .625.625.625.625 0 0 0 .625.625h.625a1.25 1.25 0 0 1 1.25 1.25v.625a.625.625 0 0 1-.625.625H3.125a.625.625 0 0 1-.625-.625V3.75A1.25 1.25 0 0 1 3.75 2.5h.625A.625.625 0 0 0 5 1.875a.625.625 0 0 1 .625-.625h8.75Z'
          />
          <path
            fill={fill}
            fillRule='evenodd'
            d='M3.9 6.997a.625.625 0 0 1 .613-.747h10.975a.625.625 0 0 1 .612.747l-2.15 10.748a1.25 1.25 0 0 1-1.225 1.005h-5.45a1.25 1.25 0 0 1-1.225-1.005L3.9 6.997Zm8.6 4.253a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z'
            clipRule='evenodd'
          />
        </>
      );
    case 'tree':
      return (
        <>
          <path
            fill={fill}
            d='M15.625 10a3.12 3.12 0 0 1-2.5 1.25 3.121 3.121 0 0 1-2.557-1.328c-.678.803-1.8 1.328-3.068 1.328-1.228 0-2.318-.492-3.002-1.252L4.375 10a3.125 3.125 0 1 1 .626-6.187L5 3.75a2.5 2.5 0 0 1 4.34-1.692 4.375 4.375 0 0 1 6.491 1.698A3.125 3.125 0 0 1 15.626 10ZM8.125 12.5s.088.436.016.835c-.332 1.837-1.07 3.968-1.89 4.79-.112.111-.079.262-.037.449.013.055.026.114.036.176h7.5c.01-.062.024-.12.036-.177.042-.186.076-.337-.036-.448-.818-.818-1.525-2.922-1.843-4.752-.082-.474-.032-.873-.032-.873-.436-.163-.9-.331-1.25-.625-.622.453-1.684.5-2.5.625Z'
          />
        </>
      );
    case 'world':
      return (
        <>
          <path
            fill={fill}
            fillRule='evenodd'
            d='M10 1.25a8.75 8.75 0 1 1 0 17.5 8.75 8.75 0 0 1 0-17.5Zm-.735 15.586c.144.016.266-.1.266-.244v-2.715a.243.243 0 0 0-.266-.244 6.288 6.288 0 0 0-1.85.484.238.238 0 0 0-.127.298c.17.487.366.934.577 1.335.175.332.358.625.543.88.035.047.086.08.144.092.233.05.471.088.713.114Zm1.47-3.203a.243.243 0 0 0-.266.244v2.715c0 .145.122.26.266.244a6.8 6.8 0 0 0 .713-.114.239.239 0 0 0 .144-.093 7.16 7.16 0 0 0 .543-.879 9.94 9.94 0 0 0 .577-1.335.238.238 0 0 0-.127-.298 6.288 6.288 0 0 0-1.85-.484Zm-.031-.945a.256.256 0 0 1-.235-.253v-1.716a.25.25 0 0 1 .25-.25h2.453c.14 0 .254.117.247.258-.041.8-.148 1.564-.306 2.275a.254.254 0 0 1-.346.175 7.316 7.316 0 0 0-2.063-.489ZM9.28 9.531a.25.25 0 0 0 .25-.25V7.565a.256.256 0 0 0-.235-.253 7.32 7.32 0 0 1-2.063-.489.254.254 0 0 0-.346.175c-.158.71-.265 1.475-.306 2.275a.247.247 0 0 0 .248.258H9.28Zm1.423-2.219a.256.256 0 0 0-.235.253v1.716c0 .138.112.25.25.25h2.453a.247.247 0 0 0 .247-.258c-.041-.8-.148-1.564-.306-2.275a.254.254 0 0 0-.346-.175 7.32 7.32 0 0 1-2.063.489Zm.031-.945a.243.243 0 0 1-.266-.244V3.408c0-.145.122-.26.266-.244.242.026.48.064.713.114a.24.24 0 0 1 .144.093c.185.254.368.547.543.88.211.4.406.847.577 1.334a.238.238 0 0 1-.127.298 6.283 6.283 0 0 1-1.85.484Zm-1.47 0c.144.015.266-.1.266-.244V3.408a.243.243 0 0 0-.266-.244c-.242.026-.48.064-.713.114a.24.24 0 0 0-.144.093 7.154 7.154 0 0 0-.543.88 9.944 9.944 0 0 0-.577 1.334.238.238 0 0 0 .127.298c.541.238 1.169.41 1.85.484Zm.031 6.321a.256.256 0 0 0 .235-.253v-1.716a.25.25 0 0 0-.25-.25H6.83a.246.246 0 0 0-.248.258c.04.8.148 1.564.306 2.275.033.153.2.233.346.175a7.316 7.316 0 0 1 2.063-.489Zm4.568 2.257c-.124-.118-.323-.06-.385.1-.16.417-.337.807-.527 1.166.463-.22.898-.492 1.298-.806a2.673 2.673 0 0 0-.386-.46Zm1.29-.394c-.104.117-.287.103-.389-.015a4.356 4.356 0 0 0-.729-.665.261.261 0 0 1-.1-.274c.225-.892.374-1.864.422-2.886a.253.253 0 0 1 .252-.242h1.982c.145 0 .26.122.244.266a6.847 6.847 0 0 1-1.683 3.816Zm-9.19-.68a.261.261 0 0 0 .1-.274 14.63 14.63 0 0 1-.422-2.886.253.253 0 0 0-.252-.242H3.408a.243.243 0 0 0-.244.266 6.848 6.848 0 0 0 1.683 3.816c.103.117.286.103.388-.015a4.35 4.35 0 0 1 .729-.665Zm-.214 1.534c.4.314.835.585 1.298.806-.19-.359-.367-.75-.527-1.166-.062-.16-.261-.218-.385-.1-.156.15-.285.305-.386.46ZM7.048 3.789c-.19.359-.367.75-.527 1.166-.062.16-.261.218-.385.1a2.675 2.675 0 0 1-.386-.46c.4-.314.835-.585 1.298-.806Zm-.984 2.614a.261.261 0 0 0-.1-.274 4.36 4.36 0 0 1-.73-.665c-.101-.118-.284-.132-.387-.015a6.847 6.847 0 0 0-1.683 3.816c-.015.144.1.266.244.266H5.39a.253.253 0 0 0 .252-.242 14.63 14.63 0 0 1 .422-2.886ZM14.61 9.53a.253.253 0 0 1-.252-.242 14.621 14.621 0 0 0-.422-2.886.261.261 0 0 1 .1-.274c.274-.2.52-.423.73-.665.101-.118.284-.132.387-.015a6.847 6.847 0 0 1 1.683 3.816.243.243 0 0 1-.244.266H14.61Zm-.36-4.936a2.67 2.67 0 0 1-.386.46c-.124.118-.323.06-.385-.1-.16-.417-.337-.807-.527-1.166.463.22.898.492 1.298.806Z'
            clipRule='evenodd'
          />
        </>
      );
    default:
      return null;
  }
};

const IconSvg = ({
  name = '',
  style = {},
  fill = '',
  viewBox = '',
  height = '24',
  width = '24',
  className = '',
  strokeWidth = 1.5,
  bgfill = 'none',
  stroke = '',
  stopColor = '',
  iconprimary = 'var(--brand-primary)'
}) => (
  <svg
    stroke={stroke}
    width={width}
    height={height}
    className={className}
    xmlns='http://www.w3.org/2000/svg'
    viewBox={viewBox || '0 0 24 24'}
    xmlnsXlink='http://www.w3.org/1999/xlink'>
    {getPath(name, { fill, strokeWidth, bgfill, stroke, stopColor, iconprimary })}
  </svg>
);

export default IconSvg;
